import React, { createRef } from "react";
import "./index.css";
import { BsyUtils } from "../../utils/Utils";
import { BsyWidget } from "../BsyWidget";
import { BsyConfig } from "../../global/BsyConfig";
import tipAlert from "../../Login/BsyAlertTip/Staticize";
import BsyIconBtn from "../BsyIconBtn";
import BsySLoading from "../BsySLoading";
import BsyDialog from "../BsyDialog";
import BsyFormMultiTab from "../BsyFormMultiTab";
import BsyTextArea from "../BsyTextArea";
import BsySignature from "../BsySignature";
import BsyUser from "../BsyUser";
import BsyFormLogPane from "../BsyFormLogPane";
import BsyAlert from "../BsyAlert";
import BsyAlertMenu from "../BsyAlertMenu";
import BsyRadioGroup from "../BsyRadioGroup";
import isEqual from "lodash/isEqual";
import rowExecuteRely_3_0, {
  memoryWidget,
} from "../../utils/rowExecuteRely_3_0";
import BsyMaskLayer from "../BsyMaskLayer";
import SubmitAnimation from "./SubmitAnimation";
import BsyAlertQrcode from "../BsyAlertQrcode";
import { SingPage } from "./SingPage";
import { dayjsUtils } from "../../utils/dayjsUtils";
import { getAfterSuffix } from "../../utils/getAfterSuffix";

export default class BsyForm extends BsyWidget {
  LAYOUT_SIZES = {
    normal: {
      text: {
        width: 350,
      },
      sn: {
        width: 350,
      },
      number: {
        width: 350,
      },
      combo: {
        width: 350,
        edge: {
          width: 350,
          height: 200,
        },
      },
      combocheck: {
        width: 350,
        edge: {
          width: 350,
          height: 200,
        },
      },
      datetime: {
        width: 350,
      },
      user: {
        width: 350,
        height: 34,
      },
      usergroup: {
        width: 740,
        height: 80,
      },
      dept: {
        width: 350,
        height: 34,
      },
      deptgroup: {
        width: 740,
        height: 80,
      },
      dataload: {
        width: 350,
      },
      image: {
        width: 350,
        formMode: !0,
      },
      upload: {
        width: 350,
      },
      location: {
        width: 350,
      },
      signature: {
        width: 350,
      },
      linkdata: {
        width: 350,
      },
      textarea: {
        width: 740,
      },
      button: {
        style: "default",
      },
      address: {
        width: 350,
      },
    },
    "grid-2": {
      text: {
        width: 350,
      },
      sn: {
        width: 350,
      },
      number: {
        width: 350,
      },
      dataload: {
        width: 350,
      },
      combo: {
        width: 350,
        edge: {
          width: 350,
          height: 200,
        },
      },
      combocheck: {
        width: 350,
        edge: {
          width: 350,
          height: 200,
        },
      },
      datetime: {
        width: 350,
      },
      user: {
        width: 350,
      },
      usergroup: {
        width: 350,
      },
      dept: {
        width: 350,
      },
      deptgroup: {
        width: 350,
      },
      image: {
        width: "100%",
        formMode: !0,
        grid2: !0,
      },
      upload: {
        width: 350,
      },
      location: {
        width: 350,
      },
      signature: {
        width: 350,
      },
      linkdata: {
        width: 350,
      },
      button: {
        style: "default",
      },
      textarea: {
        width: 350,
      },
      address: {
        width: 350,
      },
    },
    "full-line": {
      text: {
        width: 720,
      },
      sn: {
        width: 720,
      },
      number: {
        width: 720,
      },
      dataload: {
        width: 720,
      },
      formsource: {
        width: 720,
      },
      combo: {
        width: 720,
        edge: {
          width: 720,
          height: 200,
        },
      },
      combocheck: {
        width: 720,
        edge: {
          width: 720,
          height: 200,
        },
      },
      datetime: {
        width: 720,
      },
      user: {
        width: 720,
      },
      usergroup: {
        width: 720,
      },
      dept: {
        width: 720,
      },
      deptgroup: {
        width: 720,
      },
      image: {
        width: "100%",
        formMode: !0,
        grid2: !0,
      },
      upload: {
        width: 350,
      },
      location: {
        width: 350,
      },
      signature: {
        width: 350,
      },
      linkdata: {
        width: 720,
      },
      textarea: {
        width: 720,
      },
      address: {
        width: 350,
      },
    },
  };

  static defaultProps = {
    items: [],
  };

  constructor(props) {
    super({
      baseCls: "bsy-form",
      title: "",
      appId: null,
      entryId: null,
      dataId: null,
      onAfterItemCreate: null, //
      onAfterSubmit: null, //
      onSuccess: null, //数据提交成功后的事件
      onAfterCancel: null, //关闭窗口事件
      layout: "normal", //单列双列模式
      mode: "new", //new 提交数据  edit 编辑数据
      hasDataViewLink: !1,
      submitRule: BsyConfig().InvisibleSubmitRules.KEEP,
      width: 780,
      extParam: null, //扩展字段的参数
      submitUrl: "/data/create",
      submitData: null, //提交的数据
      submitText: null, //提交按钮文字
      validators: null, //数据提交前的验证
      confirmSettings: null, //提前数据前确认是否提交配置
      formTheme: null, //外链主题样式
      cancelText: null, //取消按钮文本
      ignoreOptAuth: !1, //获取控件是可编辑的权限验证
      ignoreValidate: !1, //忽略所有字段合法性的验证
      widgetOptAuth: null, //字段是否可编辑
      editValue: null, //编辑的值
      buttonPosition: "left",
      hasFooter: !0, //显示菜单
      headerHeight: 50, //表头高度
      hasHeader: !0, //显示表头
      fieldShowRules: {},
      subformFieldShowRules: null,
      onCreateMoreBtn: null,
      flow: null,
      flows: null,
      tabs: null, //标签页信息
      authGroupId: null, //权限组id
      cacheEnable: false, //数据开关
      cacheFields: [], //支持缓存的字段
      cacheAllField: !0, //是否缓存所有字段
      isEvent: false, //事件表单
      submitButton: null, //后端事件修改按钮的值
      eventType: null, //界面请求是否来源于报表请求
      popupFormPath: [], //记出弹出菜单的路径
      ...props,
    });
    this.items = [];
    this.cacheValue = {};
    this.widgetErrorMap = {};
    this.widgetVisibleMap = {};
    this.widgetItemsMap = {}; //如果被动态修改过了，则使用修改过后的 items
    this.status = this.getSideStatus();
    this.isFull = this.getfullscreenStatus();
    this.needPrint = false;
    this.wrapper = createRef();
    this.multiTab = createRef();
    this.btns = [];
    this.moreBtns = [];
    this.btnCount = 0;
    let opt = this.options;
    if (opt.data_cache) {
      if (opt.data_cache.hasOwnProperty("status")) {
        opt.cacheEnable = opt.data_cache.status;
        opt.cacheAllField = opt.data_cache.isAll;
        opt.cacheFields = opt.data_cache.fields;
      } else {
        opt.cacheEnable = opt.data_cache;
      }
    } else {
      opt.cacheEnable = false;
    }
    if (props.mode !== "edit") {
      if (this.options.submitAttr) {
        this.options.submitText = this.options.submitAttr.submitText;
      }
    }
    this.flowComment = {
      signature: null,
      comment: null,
    };
    this.formFieldsAttr = {};
    this._labelMap();
    window.FX.STATIC.EntryRecNo = null;
  }

  updateFromFieldsAttr = (name, attr) => {
    const at = { ...this.formFieldsAttr[name] };
    this.formFieldsAttr = {
      ...this.formFieldsAttr,
      [name]: {
        ...at,
        ...attr,
      },
    };
  };

  _labelMap = () => {
    var s = this,
      o = this.options;
    this.labelMap = {};
    BsyUtils.forEach(o.items, function (a1, b1) {
      if (b1.widget.type === "subform") {
        s.labelMap[b1.widget.widgetName] = b1.label;
        BsyUtils.forEach(b1.widget.items, function (a2, b2) {
          s.labelMap[[b1.widget.widgetName, b2.widget.widgetName].join(".")] = [
            b1.label,
            b2.label,
          ].join(".");
        });
      } else {
        s.labelMap[b1.widget.widgetName] = b1.label;
      }
    });
  };

  showMessage = (options={},customCallback) => {
    if (this.SubmitAnimation) {
      return;
    }

    this.SubmitAnimation = true;

    BsyMaskLayer({
      customCls: "sloading",
      onContentCreate: (ref) => {
        var showLayerRef = ref;
        return (
          <SubmitAnimation
            rowRely={this.rowRely}
            {...options}
            onCancel={() => {
              showLayerRef.close();
              this.SubmitAnimation = false;
            }}
            onSubmit={() => {
              showLayerRef.close();
              this.SubmitAnimation = false;
              if(customCallback) {
                customCallback();
              } else {
                this.doVerifyAndSubmit(this.extData);
              }
            }}
          />
        );
      },
    });
  };

  formLoadLayer = () => {
    let that = this;
    this.layerRef = null;
    if (
      !window.hasOwnProperty("extendSetLoading") ||
      window.extendSetLoading === true
    ) {
      BsyMaskLayer({
        customCls: "sloading",
        onContentCreate: (ref) => {
          that.layerRef = ref;
          return <BsySLoading />;
        },
      });
    }
  };

  formLoadLayerRemove = () => {
    this.layerRef && this.layerRef.close();
    this.layerRef = null;
  };

  _initForminitial = () => {
    //为了走事件初始化方法
    let b = this,
      c = this.options;
    if (c.hasOwnProperty("tabs") && !BsyUtils.isObjectEmpty(c.tabs)) {
      b.tabs = c.tabs;
    }
    //     if(c.mode=='new' && c.hasOwnProperty("initializeModuleEvent") && !FX.Utils.isObjectEmpty(c.initializeModuleEvent.libs))
    if (
      c.mode === "new" &&
      (window.FX.STATIC.IS_EVENT ||
        (c.hasOwnProperty("initializeModuleEvent") &&
          !window.FX.Utils.isObjectEmpty(c.initializeModuleEvent.libs)) ||
        c.hasOwnProperty("initializeDataExtendSet"))
    ) {
      if (c.eventType != "popupform") {
        let loading =
          this.element &&
          this.element.current &&
          window.FX.Utils.createLoadLayer(this.element.current, {
            isLight: !0,
            hasLoader: !0,
          });
        this.element &&
          this.element.current &&
          (this.element.current.style.display = "none");
        if (c.hasOwnProperty("initializeDataExtendSet")) {
          if (
            ((c.initializeDataExtendSet.funMode === "datahelp" ||
              c.initializeDataExtendSet.funMode === "all") &&
              !window.FX.Utils.isObjectEmpty(
                c.initializeDataExtendSet.datahelpids
              )) ||
            ((c.initializeDataExtendSet.funMode === "formEvent" ||
              c.initializeDataExtendSet.funMode === "all") &&
              !window.FX.Utils.isObjectEmpty(
                c.initializeDataExtendSet.events
              )) ||
            ((c.initializeDataExtendSet.funMode === "module" ||
              c.initializeDataExtendSet.funMode === "all") &&
              !window.FX.Utils.isObjectEmpty(c.initializeDataExtendSet.libs)) ||
            (window.FX.STATIC.IS_EVENT &&
              (c.initializeDataExtendSet.funMode === "event" ||
                c.initializeDataExtendSet.funMode === "all"))
          ) {
            let extValue = b._getExtValue();

            b.isEvent = true;
            window.FX.Utils.dataAjax(
              {
                url: "/dashboard/app/" + c.appId + "/entry/" + c.entryId,
                // async:false, //需要异步  否则会js报错
                data: {
                  forminitial: true,
                  value: extValue,
                  extDashData: c.extDashData,
                },
              },
              function (f) {
                c.items = f.entry.content.items;
                b.tabs = f.entry.tabs;
                c.submitButton = f.entry.content.submitButton || null;
                b.isEvent = false;
                b._initMain();
                b.doResize();
              },
              null,
              function () {
                loading && loading.remove();
                b.element &&
                  b.element.current &&
                  (b.element.current.style.display = "block");
              }
            );
          } else {
            loading && loading.remove();
            b.element &&
              b.element.current &&
              (b.element.current.style.display = "block");
            b._initMain();
            // b.doResize();
          }
        } else {
          b.isEvent = true;
          let extValue = b._getExtValue();
          window.FX.Utils.dataAjax(
            {
              url: "/dashboard/app/" + c.appId + "/entry/" + c.entryId,
              // async:false, //需要异步  否则会js报错
              data: {
                forminitial: true,
                value: extValue,
                extDashData: c.extDashData,
              },
            },
            function (f) {
              c.items = f.entry.content.items;
              b.tabs = f.entry.tabs;
              c.submitButton = f.entry.content.submitButton || null;
              b.isEvent = false;
              b._initMain();
              b.doResize();
              loading && loading.remove();
              b.element &&
                b.element.current &&
                (b.element.current.style.display = "block");
            },
            null,
            function () {
              loading && loading.remove();
              b.element &&
                b.element.current &&
                (b.element.current.style.display = "block");
            }
          );
        }
      } else {
        b._initMain();
      }
    } else {
      b._initMain();
    }
  };

  //获取扩展外链的value
  _getExtValue = () => {
    let parameter = BsyUtils._getRequest();
    let value = {};
    let c = this.options;
    BsyUtils.forEach(c.items, function (a1, b1) {
      let widgetName = b1.widget.widgetName;
      let v = parameter[widgetName];
      if (v === undefined) {
        widgetName = b1.widget.widgetNameAlias;
        v = parameter[widgetName];
      }

      if (v) {
        switch (b1.widget.type) {
          case "text":
          case "textarea":
          case "radiogroup":
          case "combo":
          case "sn":
          case "dept":
          case "user": {
            value[b1.widget.widgetName] = v;
            break;
          }
          case "number": {
            value[b1.widget.widgetName] = parseFloat(v);
            break;
          }
          case "datetime": {
            v = v.replace(/-/g, "/");

            let ss = new Date(v);
            if (ss === "Invalid Date") {
              if (typeof v === "string") {
                v = parseInt(v);
              }
              ss = new Date(v);
            }

            if (ss != "Invalid Date") {
              value[b1.widget.widgetName] = ss.getTime();
            }
            break;
          }
          case "address": {
            try {
              let dd = JSON.parse(v);
              if (
                dd &&
                (dd.hasOwnProperty("city") ||
                  dd.hasOwnProperty("district") ||
                  dd.hasOwnProperty("province"))
              ) {
                value[b1.widget.widgetName] = dd;
              }
            } catch (e) {
              console.log(e);
            }

            break;
          }
          case "deptgroup":
          case "usergroup":
          case "checkboxgroup":
          case "combocheck": {
            try {
              let dd = JSON.parse(v);
              if (dd) {
                value[b1.widget.widgetName] = dd;
              }
            } catch (e) {
              console.log(e);
            }
            break;
          }
          default:
        }
      }
    });
    return value;
  };

  _initMain = () => {
    const {
      items,
      appId,
      entryId,
      formId,
      flow,
      hasHeader,
      ignoreOptAuth,
      mode,
      submitButton,
      popupFormPath,
      authGroupId,
      refAppId
    } = this.options;
    this.renderIndex = 0;

    let newitems = this._replaceItemValue(items);

    if (hasHeader) {
      if (this.status == "false") {
        this.element.current.classList.remove("side");
      } else {
        this.element.current.classList.add("side");
      }

      let i1 = this.element.current.querySelector(".all i");
      let parent = BsyUtils.closestClass(this.element.current, "bsy-form-pane");
      let parent1 = BsyUtils.closestClass(
        this.element.current,
        "bsy-form-edit-pane"
      );

      i1 && (i1.className = "");
      if (this.isFull == "true") {
        if (parent) {
          parent.style.width = "100%";
        }
        if (parent1) {
          parent1.style.width = "100%";
        }
        i1 && i1.classList.add("icon-bby-collapse");
      } else {
        if (parent) parent.style.width = "80%";
        if (parent1) {
          parent.style.width = "100%";
          parent1.style.width = "80%";
        }

        i1 && i1.classList.add("icon-bby-expansion");
      }
    }

    let optAuth = {};
    let that = this;
    this.items = [];
    for (let i = 0; i < newitems.length; i++) {
      let data = newitems[i];
      let config = Object.assign(
        {},
        data.widget,
        {
          appId: appId,
          entryId: entryId,
          formId: formId || entryId,
          designAppId: refAppId || appId,
          designEntryId: formId || entryId,
          label: data.label,
          lineWidth: data.lineWidth || 12,
          description: data.description,
          ignoreOptAuth: ignoreOptAuth,
          formMode: mode,
          popupFormPath: popupFormPath || [],
          tab: data.tab,
          authGroupId: ["subform"].includes(data.widget.type)
            ? authGroupId
            : undefined,
        },
        this._getWidgetConfig(
          data.widget.type,
          data.widget.widgetName,
          items[i]
        ),
        this._getWidgetOptAuth(data)
      );
      config = this._doLayoutResize(config, data.lineWidth || 12);
      optAuth[config.widgetName] = config.visible;
      this.formFieldsAttr[config.widgetName] = {
        visible: config.visible,
        enable: config.enable,
        items: BsyUtils.isArray(config.items) ? [...config.items] : null,
        subform_create: config.subform_create,
        subform_insert: config.subform_insert,
        subform_delete: config.subform_delete,
        subform_edit: config.subform_edit,
        // subform_create:config.subform_create,
      };
      // if (config.hasOwnProperty('height')) {
      //     //兼容历史数据，有些表结构记录过，字段高度
      //     if (config.height < 34) {
      //         config.height = 34;
      //     }
      // } else {
      switch (config.type) {
        case "text":
        case "number":
        case "datetime":
        case "combo":
        case "combocheck":
        case "button":
        case "sn":
        case "dept":
        case "user":
          config.height = 34;
          break;
        default:
      }
      // }

      this.items.push({ ...config });
    }

    this.rowRely = new rowExecuteRely_3_0({
      appId: appId,
      formId: formId || entryId,
      items: newitems,
      mode: mode,
      optAuth: optAuth,
      rowData: {},
      // firstWidget:  triggerThis.options.subform ? [triggerThis.options.subform,triggerThis.options.widgetName].join('.') : triggerThis.options.widgetName,
      // subformRow:$(triggerThis.element).closest(".subform-row").index(),
      form: this,
      onWidgetError: (widget, clear) => {
        if (clear) {
          that.clearWidgetError();
          return;
        }

        if (!that.firstErrorWidget) {
          that.firstErrorWidget = widget;
        }
        that.widgetErrorMap[widget.name] = { ...widget };
        if (that.options.resultWidgets[widget.name].checkValidate) {
          that.options.resultWidgets[widget.name].checkValidate();
        } else {
          console.log(`not find checkValidate function type:${widget.type}`);
        }
        that.setWidgetError(widget);
        // console.log(that.widgetErrorMap)
      },
    });

    let wrapperWidth = 0; // this.element.current.querySelector('.btn-pane').offsetWidth;
    if (this.element.current.querySelector(".btn-pane")) {
      wrapperWidth =
        this.element.current.querySelector(".btn-pane").offsetWidth;
    }

    if (flow) {
      if (!ignoreOptAuth) {
        if (flow.print) {
          let btn = {
            text: flow.print.text,
            type: "blue",
            handler: "print",
          };
          this.btnCount++;
          if ((this.btnCount + 1) * 130 < wrapperWidth) {
            this.btns.push(btn);
          } else {
            this.moreBtns.push(btn);
          }
        }
      }

      if (flow.forward) {
        let btn = {
          text: flow.forward.text,
          type: "blue",
          handler: "forward",
        };

        if (submitButton) {
          let visible = submitButton.hasOwnProperty("visible")
            ? submitButton.visible
            : true;
          if (visible) {
            btn.text = submitButton.text || flow.forward.text;
            let styles = {};
            if (submitButton.color) {
              styles = {
                "background-color": submitButton.color,
                border: `1px solid ${submitButton.color}`,
              };
            }
            btn.style = styles;
            this.btnCount++;
            if ((this.btnCount + 1) * 130 < wrapperWidth) {
              this.btns.push(btn);
            } else {
              this.moreBtns.push(btn);
            }
          }
        } else {
          this.btnCount++;
          if ((this.btnCount + 1) * 130 < wrapperWidth) {
            this.btns.push(btn);
          } else {
            this.moreBtns.push(btn);
          }
        }
      }
      if (flow.save) {
        let btn = {
          text: flow.save.text,
          type: "blue",
          handler: "save",
        };
        this.btnCount++;
        if ((this.btnCount + 1) * 130 < wrapperWidth) {
          this.btns.push(btn);
        } else {
          this.moreBtns.push(btn);
        }
      }
      if (flow.urge) {
        let btn = {
          text: flow.urge.text,
          type: "blue",
          handler: "urge",
        };
        this.btnCount++;
        if ((this.btnCount + 1) * 130 < wrapperWidth) {
          this.btns.push(btn);
        } else {
          this.moreBtns.push(btn);
        }
      }
      if (flow.back) {
        let btn = {
          text: flow.back.text,
          type: "white",
          handler: "back",
        };
        this.btnCount++;
        if ((this.btnCount + 1) * 130 < wrapperWidth) {
          this.btns.push(btn);
        } else {
          this.moreBtns.push(btn);
        }
      }
      if (flow.sign) {
        let btn = {
          text: flow.sign.text,
          type: "white",
          handler: "sign",
        };
        this.btnCount++;
        if ((this.btnCount + 1) * 130 < wrapperWidth) {
          this.btns.push(btn);
        } else {
          this.moreBtns.push(btn);
        }
      }
      if (flow.transfer) {
        let btn = {
          text: flow.transfer.text,
          type: "white",
          handler: "transfer",
        };
        this.btnCount++;
        if ((this.btnCount + 1) * 130 < wrapperWidth) {
          this.btns.push(btn);
        } else {
          this.moreBtns.push(btn);
        }
      }
      if (flow.revoke) {
        let btn = {
          text: flow.revoke.text,
          type: "white",
          handler: "revoke",
        };
        this.btnCount++;
        if ((this.btnCount + 1) * 130 < wrapperWidth) {
          this.btns.push(btn);
        } else {
          this.moreBtns.push(btn);
        }
      }
      if (flow.close) {
        let btn = {
          text: flow.close.text,
          type: "white",
          handler: "close",
        };
        this.btnCount++;
        if ((this.btnCount + 1) * 130 < wrapperWidth) {
          this.btns.push(btn);
        } else {
          this.moreBtns.push(btn);
        }
      }
      if (flow.cancel) {
        let btn = {
          text: flow.cancel.text,
          type: "white",
          handler: "cancel",
        };
        this.btnCount++;
        if ((this.btnCount + 1) * 130 < wrapperWidth) {
          this.btns.push(btn);
        } else {
          this.moreBtns.push(btn);
        }
      }
    }

    this.setState({ showRules: {} }, () => {
      this.After();
    });
  };

  _calFormula = (formula) => {
    if (this.rowRely) {
      return this.rowRely._calFormula(formula, {});
    }
    return null;
  };

  _init = () => {
    this._initForminitial();
  };

  After = () => {
    const { editValue, cacheEnable, mode } = this.options;

    let that = this;
    if (this._isEditMode()) {
      BsyUtils.forEach(editValue, function (a, c) {
        let d = that.rowRely.getField(a);
        if (d) {
          d.setValue(c);
          d.effectItemLinkWidgets && d.effectItemLinkWidgets();
        }
      });
      this._setLinkQuery();
      this.getCacheValue();
    } else {
      if (mode === "copy") {
        BsyUtils.forEach(editValue, function (a, c) {
          let d = that.rowRely.getField(a);

          if (d) {
            switch (d.type) {
              case "sn":
                c = null;
                break;
              case "subform":
                let newD = null;
                if (!BsyUtils.isObjectEmpty(c)) {
                  newD = [];
                  BsyUtils.forEach(c, (index, data) => {
                    data.id = data._id = BsyUtils.Ids24();
                    newD.push(data);
                  });
                }
                c = newD;
                break;
              default:
                break;
            }
            d.setValue(c);
          }
        });
        this._setLinkQuery();
        this.getCacheValue();
      } else {
        this.loadFormData();
        this.getCacheValue();

        if (!(cacheEnable && this.needCache)) {
          that.rowRely.fireDefaultRely();
        }
      }
    }

    this.rowRely.getViewVisibleMap();
    this.setWidgetVisible();
  };
  _replaceItemValue = (items) => {
    let parameter = BsyUtils._getRequest();
    BsyUtils.forEach(items, function (a1, b1) {
      let widgetName = b1.widget.widgetName;
      let v = undefined;
      if (!parameter.hasOwnProperty(widgetName)) {
        widgetName = b1.widget.widgetNameAlias;
        if (parameter.hasOwnProperty(widgetName)) v = parameter[widgetName];
      } else {
        v = parameter[widgetName];
      }

      if (v !== undefined) {
        switch (b1.widget.type) {
          case "text":
          case "textarea":
          case "sn":
          case "dept":
          case "user": {
            if (v) items[a1].widget.value = v;
            else items[a1].widget.value = null;

            break;
          }
          case "number": {
            if (BsyUtils.isNumber(v)) items[a1].widget.value = parseFloat(v);
            else items[a1].widget.value = null;
            break;
          }
          case "datetime": {
            v = v.replace(/-/g, "/");

            let ss = new Date(v);
            if (ss === "Invalid Date") {
              if (typeof v === "string") {
                v = parseInt(v);
              }
              ss = new Date(v);
            }

            if (ss !== "Invalid Date") {
              items[a1].widget.value = ss.getTime();
            } else {
              items[a1].widget.value = null;
            }
            break;
          }
          case "address": {
            try {
              let dd = JSON.parse(v);
              if (
                dd &&
                (dd.hasOwnProperty("city") ||
                  dd.hasOwnProperty("district") ||
                  dd.hasOwnProperty("province"))
              ) {
                items[a1].widget.value = dd;
              }
            } catch (e) {
              console.log(e);
              items[a1].widget.value = null;
            }
            break;
          }
          case "radiogroup":
          case "combo": {
            let isselect = false;
            if (items[a1].widget.items) {
              BsyUtils.forEach(items[a1].widget.items, function (index, item) {
                delete items[a1].widget.items[index].selected;
                if (item.value === v) {
                  items[a1].widget.items[index].selected = !0;
                  isselect = true;
                }
              });
              if (!isselect) {
                items[a1].widget.items.push({
                  selected: !0,
                  value: v,
                  text: v,
                });
              }
            }
            items[a1].widget.value = v;
            break;
          }
          case "checkboxgroup":
          case "combocheck": {
            try {
              let dd = JSON.parse(v);
              if (dd) {
                if (items[a1].widget.items) {
                  BsyUtils.forEach(
                    items[a1].widget.items,
                    function (index, item) {
                      delete items[a1].widget.items[index].selected;
                      if (dd.indexOf(item.value) > -1) {
                        items[a1].widget.items[index].selected = !0;
                      }
                    }
                  );
                }
                items[a1].widget.value = dd;
              } else {
                if (items[a1].widget.items) {
                  BsyUtils.forEach(items[a1].widget.items, function (index) {
                    delete items[a1].widget.items[index].selected;
                  });
                }
              }
            } catch (e) {
              console.log(e);
              if (items[a1].widget.items) {
                BsyUtils.forEach(items[a1].widget.items, function (index) {
                  delete items[a1].widget.items[index].selected;
                });
              }
            }
            break;
          }
          case "deptgroup":
          case "usergroup": {
            try {
              let dd = JSON.parse(v);
              if (dd) {
                items[a1].widget.value = dd;
              }
            } catch (e) {
              console.log(e);
              items[a1].widget.value = [];
            }

            break;
          }
          default:
        }
      }
    });
    return items;
  };
  _getTabItems = () => {
    var t = this.options,
      s = this,
      r = [];
    const { items } = this;
    if (BsyUtils.isObjectEmpty(items)) {
      return [];
    }

    BsyUtils.forEach(t.items, function (t, e) {
      var i, a, n;
      if (e.tab) {
        a = !0;
        n = (i = { ...e.widget, ...s._getWidgetOptAuth(e) }).widgetName;

        if (
          !i.visible ||
          (s.widgetVisibleMap && !1 === s.widgetVisibleMap[n])
        ) {
          a = !1;
        }

        if (a) {
          r.push({ ...items[t] });
        } else {
          r.push({
            ...items[t],
            ...{
              hidden: !0,
            },
          });
        }
      }
    });
    return r;
  };

  _hasMultiTab = () => {
    let t = this.options;
    if (BsyUtils.isObjectEmpty(t.multiTabs)) return !1;
    let e = this._getTabItems();
    return !BsyUtils.isObjectEmpty(e);
  };

  _getNameMap = () => {
    let a = this.options,
      b = this,
      d = a.resultWidgets;
    this.nameMap = {};
    for (let e in d) {
      let f = d[e];
      if (f && BsyUtils.isValueWidget(f.getWidgetType())) {
        // let g = f.getValue();

        switch (f.options.type) {
          case "subform": {
            let m = f.getNameMap();
            b.nameMap = { ...b.nameMap, ...m };
            break;
          }
          case "usergroup":
          case "deptgroup":
          case "user":
          case "dept": {
            BsyUtils.forEach(f.selectMap, function (a1, b1) {
              b.nameMap[a1] = b1.name || b1.nickname;
            });
            break;
          }
          default:
        }
      }
    }
  };

  _getSubformIds = (name) => {
    let f = this.getWidgetByName(name);
    if (f) {
      let g = f.getObjectValue();
      let ids = [];
      BsyUtils.forEach(g, function (id, v) {
        ids.push(v.id);
      });
      return ids;
    } else {
      return [];
    }
  };
  _doLayoutResize = (b, c) => {
    let d = this.options;

    this.LAYOUT_SIZES[d.layout] &&
      this.LAYOUT_SIZES[d.layout][b.type] &&
      (b = Object.assign(b, this.LAYOUT_SIZES[d.layout][b.type]));
    if ("grid-2" === d.layout && 12 === c) {
      if ("linkquery" === b.type || "linkdata" === b.type) {
        b = Object.assign(b, {
          layoutSize: this.LAYOUT_SIZES["full-line"],
        });
      } else {
        b = Object.assign(b, this.LAYOUT_SIZES["full-line"][b.type]);
      }
    }
    return b;
  };

  _isPreviewMode = () => {
    return "preview" === this.options.mode;
  };

  _hasContactWidgets = (a) => {
    return a && ("combo" === a.type || "radiogroup" === a.type) && !a.async;
  };

  _isEditMode = () => {
    return "edit" === this.options.mode || "module" === this.options.mode;
  };

  //20231114
  fireWidgetRelyEvent = function (a, b, subformMode) {
    if (subformMode === "subform-delete") {
      this.rowRely.fireWidgetRelyEvent(a, b);
    } else {
      this.rowRely.fireEvent(a, () => {
        this.rowRely.fireWidgetRelyEvent(a, null);
      });
    }
  };
  fireSubformRowRely = function (e, t, n) {
    this.rowRely.fireSubformRowRely(e, t, n);
  };

  _addLinkQuery = (a) => {
    if (a && "linkquery" === a.type) {
      this.linkQueryWidgets || (this.linkQueryWidgets = []);
      this.linkQueryWidgets.push(a);
    }
  };
  _setLinkQuery = (tab) => {
    let a = this;
    BsyUtils.forEach(this.linkQueryWidgets, function (b, c) {
      if (tab) {
        if (c.tab && c.tab === tab) {
          a._getLinkQueryData(c);
        }
      } else {
        a._getLinkQueryData(c);
      }
    });
  };

  _renderTabTextArea = (nowTab) => {
    let that = this;
    BsyUtils.forEach(this.rowRely.itmes, function (b, c) {
      const { tab, widget } = c;
      if (tab) {
        const field = that.rowRely.getField(widget.widgetName);
        if (field.tab && field.tab === nowTab) {
          if (field.type === "textarea") field.field.setHeight();
        }
      }
    });
  };

  _setTabLink = (tab) => {
    let that = this;
    let widgets = this.items.filter((event) => {
      if (event.tab === tab) {
        return true;
      }
      return false;
    });
    BsyUtils.forEach(widgets, function (a1, b1) {
      let field = that.getWidgetByName(b1.widgetName);
      if (field && field.field) {
        that._getLinkQueryData(field.field);
      }
    });
  };

  _getLinkQueryData = (b) => {
    let c = this;

    if ("linkquery" === b.type) {
      let d = b.path,
        e = null;
      if (b.subform) {
        e = b.rowIdx;
      }

      this.rowRely.rely.setStateMap(d, -1, b.rowId);
      this.rowRely.rely.setAsyncMap(d, -1, b.rowId);

      // this.formManager.rowRely.rely.setStateMap(d, this.formManager.rowRely.rely.RELY_END);
      // this.formManager.rowRely.rely.setAsyncMap(d, this.formManager.rowRely.rely.RELY_END);

      let f = {},
        g = [],
        h = b.linkForm,
        refAppid = b.refAppid;
      if (h) {
        let i = !0;
        if (BsyUtils.isArray(b.linkFilter)) {
          //老的模式
          BsyUtils.forEach(b.linkFilter, function (a, b) {
            let d = c.getWidgetByName(b.rely, e);
            if (d) {
              let f = d.getLinkValue();
              return BsyUtils.isObjectEmpty(f)
                ? ((i = !1), !1)
                : void g.push(c.rowRely._createDataFilter(d.field, f, b.link));
            }
          });
          if (i) {
            if (!BsyUtils.isObjectEmpty(g)) {
              f[h] = g;
              b.field.reload(f);
            } else {
              b.field.reload({});
            }
          } else {
            b.field.reload({});
          }
        } else {
          if (
            !BsyUtils.isObjectEmpty(b.linkFilter) &&
            !BsyUtils.isObjectEmpty(b.linkFilter.cond)
          ) {
            let go = true;
            let linkFilter = JSON.parse(JSON.stringify(b.linkFilter));
            BsyUtils.forEach(linkFilter.cond, function (a, b1) {
              b1.form =
                !refAppid || window.FX.STATIC.APPID === refAppid
                  ? h
                  : [h, refAppid].join("@");
              if (b1.valueMode === "depend") {
                let tt = [];
                BsyUtils.forEach(b1.value, function (k, name) {
                  let d = c.getWidgetByName(name, e);
                  if (d) {
                    let f = d.getLinkValue();
                    if (f) {
                      let type = d.type || d.options.type;
                      switch (type) {
                        case "datetime": {
                          let format = (d && d.format) || "yyyy-MM-dd";

                          let dc = dayjsUtils.timeToTZ(f);

                          if (dc != "Invalid Date") {
                            f = BsyUtils.date2Str(dc, format);
                          } else {
                            f = null;
                          }
                          tt.push(f);
                          break;
                        }
                        case "user":
                        case "dept": {
                          if (!BsyUtils.isObjectEmpty(f)) {
                            tt.push(f);
                          }
                          break;
                        }
                        case "usergroup":
                        case "deptgroup": {
                          if (!BsyUtils.isObjectEmpty(f)) {
                            tt = tt.concat(f);
                          }
                          break;
                        }
                        case "linkdata": {
                          if (!BsyUtils.isObjectEmpty(f)) {
                            tt.push(f.key);
                          }
                          break;
                        }
                        default: {
                          if (BsyUtils.isArray(f)) {
                            tt = tt.concat(f);
                          } else {
                            tt.push(f);
                          }
                        }
                      }
                    } else {
                      if (linkFilter.rel != "or") {
                        i = !1;
                      }
                      // TODO 修复时间范围只选一个是也会联动
                      if (tt.length) {
                        i = true;
                      }
                      return !1;
                    }
                  }
                });
                b1.value = tt;
              } else if (b1.valueMode === "custom") {
                b1.value = (b1.value || []).map(item => {
                  // if (item === "100000000000000000000002") {
                  //   return window.FX.STATIC?.user?._id;
                  // }
                  return item;
                });
              }

              if (b1.method !== "not_empty" && b1.method !== "empty") {
                if (BsyUtils.isObjectEmpty(b1.value)) {
                  if (linkFilter.rel !== "or") {
                    go = false;
                  }
                }
              }

              // if(!BsyUtils.isObjectEmpty(b.value))
              // {
              //     dd.push(1);
              // }
            });
            if (i) {
              if (go) {
                b.field.reload(linkFilter);
              } else {
                b.field.reload({});
              }
            } else {
              b.field.reload({});
            }
          }
        }
      }
    }
  };
  _isSubformWidget = (a) => {
    return BsyUtils.isSubformWidget(a);
  };
  getWidgetByName = (a, b) => {
    let c = this.options;
    if (BsyUtils.isEmpty(a) || !c.resultWidgets) return null;
    let d;
    if (this._isSubformWidget(a)) {
      let e = c.resultWidgets[[a.split(".")[0]]];
      e && (d = e.getWidgetByName(a.split(".")[1], b));
    } else d = c.resultWidgets[a];
    return d;
  };

  getCacheValue = () => {
    const { resultWidgets } = this.options;
    let that = this;
    this.cacheValue = {};
    BsyUtils.forEach(resultWidgets, (a1, b2) => {
      if (b2.getWidgetType() === "subform")
        that.cacheValue[a1] = b2.getObjectValue();
      else that.cacheValue[a1] = b2.getValue();
    });
    return this.cacheValue;
  };

  setCacheValue = () => {
    const { resultWidgets } = this.options;
    let that = this;
    BsyUtils.forEach(resultWidgets, (a1, b2) => {
      b2.setValue(that.cacheValue[a1]);
    });
  };

  setWidgetVisible = (widget, force) => {
    let that = this;
    const { ignoreOptAuth } = this.options;
    if (ignoreOptAuth) {
      return;
    }

    if (widget) {
      if (widget.subform) {
        let subname = widget.subform.widgetName;
        if (that.rowRely.subVisbleMaps.hasOwnProperty(subname)) {
          that.options.resultWidgets[subname].setSubVisibleMap(
            that.rowRely.subVisbleMaps[subname],
            that.rowRely.subColumnVisibleMaps[subname]
          );
        }
        return;
      }
      if (widget.type === "subform") {
        let subname = widget.path;
        if (that.rowRely.subVisbleMaps.hasOwnProperty(widget.path)) {
          that.options.resultWidgets[subname].setSubVisibleMap(
            that.rowRely.subVisbleMaps[subname],
            that.rowRely.subColumnVisibleMaps[subname]
          );
        }
        return;
      }
      dealShowRules();
    } else {
      dealShowRules();
      BsyUtils.forEach(that.rowRely.subVisbleMaps, (key, component) => {
        that.options.resultWidgets[key].setSubVisibleMap(
          component,
          that.rowRely.subColumnVisibleMaps[key]
        );
      });
    }

    function dealShowRules() {
      if (!isEqual(that.rowRely.showRules, that.state.showRules) || force) {
        var tabs = {};
        BsyUtils.forEach(that.rowRely.showRules, function (a, c) {
          if (a.indexOf("tab_") > -1) {
            //标签页的特殊处理
            tabs[a] = c;
            return;
          }
          that._setWidgetVisible(a, c);
        });

        that.setState(
          {
            showRules: that.rowRely.showRules,
          },
          () => {
            if (that.multiTab && that.multiTab.current) {
              that._refreshMultiTab(tabs);
            }
          }
        );
      }
    }


  };
  //后台影响前端 标签页规则
  _setTabs = (tabs) => {
    if (BsyUtils.isObjectEmpty(tabs)) {
      return;
    }
    if (this.multiTab) {
      var tabitem =
        this.multiTab.current.element.current.querySelectorAll(".tab-item");
      var widget =
        this.multiTab.current.element.current.querySelectorAll(".widget-view");
      if (!BsyUtils.isObjectEmpty(tabs.hide)) {
        BsyUtils.forEach(tabs.hide, function (a, b) {
          if (tabitem[b]) {
            tabitem[b].style.display = "none";
          }
          if (widget[b]) {
            widget[b].style.display = "none";
          }
          // $(tabitem.eq(b)).hide();
          // $(widget.eq(b)).addClass("hide");
        });
      }
      if (
        tabs.select !== undefined &&
        BsyUtils.isNumber(tabs.select) &&
        BsyUtils.isNumber(tabs.select) > -1
      ) {
        if (tabs.select >= this.options.multiTabs.length) {
          tabs.select = this.options.length > 1 ? this.options.length - 1 : 0;
        }
        if (tabitem[tabs.select]) {
          tabitem[tabs.select].style.display = "";
          tabitem[tabs.select].click();
        }
        // $(tabitem.eq(c.select)).show();
        // $(tabitem.eq(c.select)).click();
      }
    }
  };

  _getWidgetConfig = (type, widgetName, item) => {
    let that = this;
    let opt = this.options;
    // const type = items.widget.type;
    // const widgetName = items.widget.widgetName;
    if (!opt.resultWidgets) {
      opt.resultWidgets = {};
    }

    let config = {
      form: this,
      getContext: (e) => {
        opt.resultWidgets[e.options.widgetName] = e;

        //20231114
        var def = new memoryWidget({
          ...item,
          value: e.getValue(),
          field: e,
          formMode: opt.mode,
        });

        def.setVisible(e.getVisible());
        e._bindField(that.rowRely.registerField(def));
        that._addLinkQuery(def);
      },
      onStopEdit: function (val, opt, triggerThis, subformMode) {
        that.getCacheValue();
        triggerThis.setMemValue(subformMode);

        opt && opt.onenterClearText && opt.onenterClearText();

        return;
      },
      onFormEvent: function (val, opt, triggerThis) {
        that.getCacheValue();
        if (
          triggerThis.options.type === "text" ||
          triggerThis.options.type === "subform_text"
        ) {
          this.setMemValue();

          return;

          // let name = triggerThis.getWidgetName();
          // let subindex = -1;
          // if (triggerThis.options.subform) {
          //     name = [triggerThis.options.subform, name].join('.');
          //     subindex = triggerThis.options.rowIdx;
          // }
          // let mode = '';
          // if (triggerThis.options.type === 'subform') {
          //     mode = 'delete';
          // } else {
          //     that.formManager.setFieldData(name, val, subindex)
          // }

          // that._runNewRely(triggerThis, null, mode);
          // setTimeout(() => {
          //     that.saveFormData();
          // }, 100)
        }
        return;
      },
      onBeforeInit: function (value, sc, triggerThis, config) {
        if (config) {
          let e = config;
          // if (BsyUtils.isNull(config.value) && BsyUtils.isNull(value)) {
          let t = e.rely;
          if (
            t &&
            t.widgets &&
            0 === t.widgets.length &&
            t.formula &&
            !that._isEditMode()
          ) {
            e.value = that._calFormula(t.formula.formula, {});
          }

          // t && t.formula && BsyUtils.isObjectEmpty(t.widgets) && !that._isEditMode() && (e.value = that._calFormula(t.formula.formula, {}))
          // }
          return;
        }
        // 2024 01 05 当字段设置公式uuid，会导致出现逻辑错误
        if (triggerThis.options.subform) {
          return;
        }

        let a = triggerThis.options.rely;
        a &&
          a.widgets &&
          0 === a.widgets.length &&
          a.formula &&
          !that._isEditMode() &&
          (triggerThis.options.value = that._calFormula(a.formula.formula, {}));
      },
    };

    switch (type) {
      case "text": {
        config.onAfterEdit = (val, config, triggerThis) => {
          // triggerThis.field.setValue(val);
        };
        break;
      }
      case "combo":
      case "combocheck": {
        config.onBeforeAsync = function (val, empty, widgetThis) {
          let a = widgetThis.options.async.data;
          return a ? that.rowRely._iterAddFilter(widgetThis.field) : null;
        };
        break;
      }
      case "upload":
      case "image": {
        config.uploadTokenURL = "/file/upload_token";
        config.onFileSizeLimit = () => {
          return BsyUtils.Vip.getUploadMFS();
        };
        config.onGetFormData = function () {
          return that.getCacheValue();
        };
        break;
      }
      case "linkdata": {
        config.onBeforeLinkData = (b, dz, trthis) => {
          let e = trthis.options.linkForm;
          let refAppid = trthis.options.refAppid;
          if (e && trthis.options.linkFilter?.cond?.length) {
            let f = [],
              g = {};

            if (BsyUtils.isArray(b)) {
              BsyUtils.forEach(b, function (b, e) {
                let g = -1;
                if (BsyUtils._isSubformWidget(e.rely)) {
                  g = trthis.options.rowIdx;
                }

                // BsyUtils._isSubformWidget(e.rely) && (g = a(d).closest(".subform-row").index());
                let h = that.rowRely.getField(e.rely, g);
                if (h) {
                  let i = h.getLinkValue();
                  BsyUtils.isObjectEmpty(i) ||
                    f.push(that.rowRely._createDataFilter(h, i, e.link));
                }
              });
              g[e] = f;
              return g;
              // this.reload(g)
            } else {
              if (
                !BsyUtils.isObjectEmpty(b) &&
                !BsyUtils.isObjectEmpty(b.cond)
              ) {
                let go = true;
                let linkFilter = JSON.parse(JSON.stringify(b));
                BsyUtils.forEach(linkFilter.cond, function (a, b1) {
                  b1.form =
                    !refAppid || opt.appId === refAppid
                      ? e
                      : [e, refAppid].join("@");
                  if (b1.valueMode === "depend") {
                    let tt = [];
                    BsyUtils.forEach(b1.value, function (k, name) {
                      let g = -1;
                      // c._isSubformWidget(name) && (g = window.$(d).closest(".subform-row").index());

                      if (BsyUtils._isSubformWidget(name)) {
                        g = trthis.options.rowIdx;
                      }

                      let d1 = name.includes(".")
                        ? that.rowRely.getFieldIndex(name, g)
                        : that.rowRely.getField(name, g);
                      if (d1) {
                        let f = d1.getLinkValue();
                        if (f) {
                          switch (d1.type) {
                            case "datetime": {
                              tt.push(
                                BsyUtils.date2Str(dayjsUtils.timeToTZ(f), d1.format)
                              );
                              break;
                            }
                            case "usergroup":
                            case "deptgroup":
                            case "subform_usergroup":
                            case "subform_deptgroup": {
                              if (!BsyUtils.isObjectEmpty(f)) {
                                tt = tt.concat(f);
                              }
                              break;
                            }
                            default: {
                              if (BsyUtils.isArray(f)) {
                                tt = tt.concat(f);
                              } else {
                                tt.push(f);
                              }
                            }
                          }
                        }
                        // if(f)
                        // {
                        //     tt.push(f)
                        // }
                      }
                    });
                    b1.value = tt;
                    if (b1.method != "not_empty" && b1.method != "empty") {
                      if (BsyUtils.isObjectEmpty(b1.value)) {
                        if (linkFilter.rel != "or") {
                          go = false;
                        }
                      }
                    }
                  } else if (b1.valueMode === "custom") {
                    b1.value = (b1.value || []).map(item => {
                      // if (item === "100000000000000000000002") {
                      //   return window.FX.STATIC?.user?._id;
                      // }
                      return item;
                    });
                  }
                });
                if (go) {
                  return linkFilter;
                  // this.reload(linkFilter)
                } else {
                  // this.reload({})
                  return {};
                }
              }
            }
          }
          return {
            all: [],
          };
        };
        break;
      }
      case "subform": {
        config = {
          rootElement: this.element.current,
          ...config,
          mode: opt.mode,
          onBeforeWidgetCreate: function (b, d, i) {
            b = {
              ...b,
              ...that._getWidgetConfig(b.type, b.widgetName, i),
              // onBeforeInit: function (value, abc, _this, opt) {
              //     let e = opt || this.options;
              //     if (BsyUtils.isNull(d)) {
              //         let t = e.rely;
              //         t && t.widgets && 0 === t.widgets.length && t.formula && !that._isEditMode() && (e.value = that._calFormula(t.formula.formula, {}))
              //         // t && t.formula && BsyUtils.isObjectEmpty(t.widgets) && (e.value = that._calFormula(t.formula.formula, {}))
              //     }
              // }
            };
            return b;
          },
          onAfterWidgetCreate: function (a) {
            // console.log("onAfterWidgetCreate")
            that._addLinkQuery(a);
            return that.rowRely.registerField(a);
            // e._bindField(that.rowRely.registerField(def));
            // that.formManager.rowRely.rely.addDefaultRely(a);
          },
          onDeleteRow: function (a) {
            return that.rowRely.removeField(a);
          },
          onDeleteAll: function (a) {
            return that.rowRely.removeSubformAllField(a);
          },
          onGetWidget: function (a) {
            return that.rowRely.fieldMap[a];
          },

          onRenderSucess: function () {
            // that._setLinkQuery()
          },
          onBeforeRowEdit: function () {
            // console.log("onBeforeRowEdit");
            // return BsyUtils.applyFunc(c, i.options.onRowEdit, [el], !1)
          },
          onAfterImport: function (data) {
            // console.log("onAfterImport");
            that.getCacheValue();
            var triggerThis = this;
            let { extendSet, items } = this.options;
            let triggerFieldMode = extendSet.triggerFieldMode;
            let triggerField = extendSet.triggerField;
            let triggerFields = extendSet.triggerFields;

            let mapFields = [];

            if (data.length) {
              let subform = this.options.widgetName;
              BsyUtils.forEach(items, (k, y) => {
                mapFields.push([subform, y.widget.widgetName].join("."));
              });

              var multiFieldCallBack = (widget, n, callback, closeCallback) => {
                if (widget) {
                  function triggerControlSubform(b11, rowIdx, cb) {
                    let rowId = triggerThis.dataSource[rowIdx].rowId;
                    let b1 = that.rowRely.getField(widget, rowId);
                    if (!b1) {
                      cb && cb();
                      return;
                    }
                    that.rowRely.fireEvent(
                      b1,
                      () => {
                        cb && cb();
                      },
                      "import-subform-field"
                    );
                  }
                  function cb() {
                    if (nindex < n) {
                      nindex++;
                      triggerControlSubform(widget, nindex - 1, cb);
                    } else {
                      if (callback) {
                        that.rowRely.dealRelys([widget]);
                        callback();
                      } else {
                        that.setFormValueIng = false;
                        closeCallback && closeCallback();
                      }
                    }
                  }

                  var nindex = 1;
                  triggerControlSubform(widget, nindex - 1, cb);
                }
              };
              let layerRef = null;
              BsyMaskLayer({
                customCls: "sloading",
                onContentCreate: (ref) => {
                  layerRef = ref;
                  return <BsySLoading />;
                },
              });

              that.rowRely.fireEvent(
                triggerThis.field,
                () => {
                  switch (triggerFieldMode) {
                    case "fixed": {
                      // that._runNewRely(triggerThis)

                      if (triggerField) {
                        that.setFormValueIng = true;
                        // let a = that.getWidgetByName(triggerField);
                        if (BsyUtils._isSubformWidget(triggerField)) {
                          let n = this.dataSource.length;

                          multiFieldCallBack(triggerField, n, null, () => {
                            layerRef && layerRef.close();
                            that.setFormValueIng = false;
                            that.rowRely.dealRelys([triggerField]);
                            that.rowRely.fireFixedRely([triggerField]);
                          });
                        } else {
                          let a = that.rowRely.getField(triggerField);
                          if (a) {
                            that.rowRely.fireEvent(
                              a,
                              () => {
                                layerRef && layerRef.close();
                                that.setFormValueIng = false;
                                that.rowRely.dealRelys([triggerField]);
                                that.rowRely.fireFixedRely([triggerField]);
                              },
                              "import-subform-field"
                            );
                          }
                        }
                      } else {
                        layerRef && layerRef.close();
                      }
                      break;
                    }
                    case "all": {
                      that.setFormValueIng = true;
                      let dataCount = this.dataSource.length;
                      let fieldIndex = 0;
                      function callFieldcb() {
                        fieldIndex++;
                        var trigger = mapFields[fieldIndex];
                        if (trigger)
                          multiFieldCallBack(trigger, dataCount, callFieldcb);
                        else {
                          layerRef && layerRef.close();
                          that.setFormValueIng = false;
                          that.rowRely.batchRowRely(triggerThis.field);
                        }
                      }
                      multiFieldCallBack(
                        mapFields[fieldIndex],
                        dataCount,
                        callFieldcb
                      );

                      break;
                    }
                    case "multiple": {
                      if (!BsyUtils.isObjectEmpty(triggerFields)) {
                        that.setFormValueIng = true;
                        let dataCount = this.dataSource.length;
                        let fieldIndex = 0;
                        function callFieldcb() {
                          fieldIndex++;
                          var trigger = triggerFields[fieldIndex];
                          if (trigger)
                            multiFieldCallBack(trigger, dataCount, callFieldcb);
                          else {
                            layerRef && layerRef.close();
                            that.setFormValueIng = false;
                            if (!BsyUtils.isObjectEmpty(triggerFields)) {
                              that.rowRely.dealRelys(triggerFields);
                              that.rowRely.fireFixedRely(triggerFields);
                            }
                            // that.rowRely.batchRowRely(triggerThis.field)
                          }
                        }
                        multiFieldCallBack(
                          triggerFields[fieldIndex],
                          dataCount,
                          callFieldcb
                        );
                      }
                      break;
                    }
                    default: {
                      layerRef && layerRef.close();
                    }
                  }
                  setTimeout(() => {
                    that.rowRely.getViewVisibleMap();
                    that.setWidgetVisible();
                    that.saveFormData();
                  }, 100);
                },
                "import"
              );
            }

            // setTimeout(() => {
            //   that.rowRely.getViewVisibleMap();
            //   that.setWidgetVisible();
            //   that.saveFormData();
            // }, 100);
          },

          onGetFormData: function () {
            return that.getCacheValue();
          },
          onSetFormValue: function () {
            that.getCacheValue();
            let triggerFieldMode = this.options.loaddataconfig.triggerFieldMode;
            let triggerField = this.options.loaddataconfig.triggerField;
            let triggerFields = this.options.loaddataconfig.triggerFields;
            let triggerControl = this.options.loaddataconfig.triggerControl;
            let triggerWidget = this.options.loaddataconfig.triggerWidget;
            if (this.options.loaddataconfig.extendSet) {
              triggerFieldMode =
                this.options.loaddataconfig.extendSet.triggerFieldMode ||
                triggerFieldMode;
              triggerField =
                this.options.loaddataconfig.extendSet.triggerField ||
                triggerField;
              triggerFields =
                this.options.loaddataconfig.extendSet.triggerFields ||
                triggerFields;
              triggerControl =
                this.options.loaddataconfig.extendSet.triggerControl;
              triggerWidget =
                this.options.loaddataconfig.extendSet.triggerWidget;
            }

            let mapFields = this.options.loaddataconfig.mapFields;
            var subform = this.options.widgetName;
            var fields = [];
            for (var i = 0; i < mapFields.length; i++) {
              fields.push([subform, mapFields[i].field].join("."));
            }
            let layerRef = null;
            BsyMaskLayer({
              customCls: "sloading",
              onContentCreate: (ref) => {
                layerRef = ref;
                that.rowRely.fireEvent(
                  this.field,
                  () => {
                    layerRef && layerRef.close();
                    switch (triggerFieldMode) {
                      case "fixed": {
                        if (triggerField) {
                          that.rowRely.dealRelys([triggerField]);
                          that.rowRely.fireFixedRely([triggerField]);
                        } else {
                          if (triggerControl) {
                            that.rowRely.dealRelys([triggerControl]);
                          }

                          if (triggerWidget) {
                            that.rowRely.fireFixedRely([triggerWidget]);
                          }
                        }
                        // that.rowRely.makeAsyncState(this.field);
                        break;
                      }
                      case "all": {
                        that.rowRely.dealRelys(fields);
                        that.rowRely.batchRowRely(this.field);

                        break;
                      }
                      case "multiple": {
                        if (!BsyUtils.isObjectEmpty(triggerFields)) {
                          that.rowRely.dealRelys(triggerFields);
                          that.rowRely.fireFixedRely(triggerFields);
                          // that.rowRely.makeAsyncState(this.field);
                        }
                        break;
                      }
                      default: {
                        if (triggerControl) {
                          that.rowRely.dealRelys([triggerControl]);
                        }

                        if (triggerWidget) {
                          that.rowRely.fireFixedRely([triggerWidget]);
                        }
                        // that.rowRely.makeAsyncState(this.field);
                      }
                    }

                    setTimeout(() => {
                      that.rowRely.getViewVisibleMap();
                      that.setWidgetVisible();
                      that.saveFormData();
                    }, 100);
                  },
                  "dataload"
                );
                return <BsySLoading />;
              },
            });
          },
          onRowChange: function (rows, subindex, triggerThis) {
            that.fireRowRely(triggerThis, subindex);
            setTimeout(() => {
              that.saveFormData();
            }, 100);
            // return
            // }
            // BsyUtils.forEach(t, function(t, e) {
            //     // _this._triggerFixedWidget([e.options.subform,e.options.widgetName].join('.'),true);
            //     _this._callFormula( e , null );
            // });
          },
          onRelyLimit: function (cb, widget) {
            BsyUtils.applyFunc(that, opt.onRelyLimit, [cb, widget], !1);
          },
        };

        break;
      }
      case "dataload": {
        config.onGetFormData = () => {
          return that.getCacheValue();
        };
        config.onSetFormValue = (data, wdt, config) => {
          let subvalue = {};
          let subform = null;
          BsyUtils.forEach(data, (a1, b1) => {
            if (BsyUtils.isSubformWidget(a1)) {
              let d1 = a1.split(".");
              subvalue[d1[1]] = b1;
              subform = d1[0];
            } else {
              let widget = that.getWidgetByName(a1);
              if (widget) {
                widget.field.setValue(b1);
              }
              // that.options.resultWidgets[a1].setValue(b1)
            }
          });
          if (subform) {
            let widget = that.getWidgetByName(subform); //that.options.resultWidgets[subform];
            if (widget) {
              let val = widget.getValue();
              let index = config.options.rowIdx;
              val[index] = { ...val[index], ...subvalue };
              widget.setValue(val);
            }
          }
          that.getCacheValue();
          let layerRef = null;
          BsyMaskLayer({
            customCls: "sloading",
            onContentCreate: (ref) => {
              layerRef = ref;
              that.rowRely.fireEvent(
                config.field,
                () => {
                  let triggerFieldMode =
                    config.options.loaddataconfig.triggerFieldMode;
                  let triggerField = config.options.loaddataconfig.triggerField;
                  let triggerFields =
                    config.options.loaddataconfig.triggerFields;
                  let triggerControl =
                    config.options.loaddataconfig.triggerControl;
                  let triggerWidget =
                    config.options.loaddataconfig.triggerWidget;
                  if (config.options.loaddataconfig.extendSet) {
                    triggerFieldMode =
                      config.options.loaddataconfig.extendSet
                        .triggerFieldMode || triggerFieldMode;
                    triggerField =
                      config.options.loaddataconfig.extendSet.triggerField ||
                      triggerField;
                    triggerFields =
                      config.options.loaddataconfig.extendSet.triggerFields ||
                      triggerFields;
                    triggerControl =
                      config.options.loaddataconfig.extendSet.triggerControl ||
                      triggerControl;
                    triggerWidget =
                      config.options.loaddataconfig.extendSet.triggerWidget ||
                      triggerWidget;
                  }
                  let mapFields = config.options.loaddataconfig.mapFields;

                  var fields = [];
                  for (var i = 0; i < mapFields.length; i++) {
                    fields.push(mapFields[i].field);
                  }
                  layerRef && layerRef.close();
                  switch (triggerFieldMode) {
                    case "fixed": {
                      if (triggerField) {
                        that.rowRely.dealRelys([triggerField]);
                      } else {
                        if (triggerControl) {
                          that.rowRely.dealRelys([triggerControl]);
                        }

                        if (triggerWidget) {
                          that.rowRely.fireFixedRely([triggerWidget]);
                        }
                      }

                      break;
                    }
                    case "all": {
                      that.rowRely.dealRelys(fields);
                      that.rowRely.fireFixedRely(fields);

                      break;
                    }
                    case "multiple": {
                      if (!BsyUtils.isObjectEmpty(triggerFields)) {
                        that.rowRely.dealRelys(triggerFields);
                        that.rowRely.fireFixedRely(triggerFields);
                      }
                      break;
                    }
                    default: {
                      if (triggerControl) {
                        that.rowRely.dealRelys([triggerControl]);
                      }

                      if (triggerWidget) {
                        that.rowRely.fireFixedRely([triggerWidget]);
                      }
                    }
                  }

                  setTimeout(() => {
                    that.rowRely.getViewVisibleMap();
                    that.setWidgetVisible();
                    that.saveFormData();
                  }, 100);
                },
                "dataload"
              );

              return <BsySLoading />;
            },
          });
        };
        break;
      }
      case "button": {
        config.mode = "blue";
        config.click = (event, sc, triggerThis) => {
          // return that.getCacheValue();
          // let name = triggerThis.getWidgetName();
          // let subindex = -1;
          // if (triggerThis.options.subform) {
          //     name = [triggerThis.options.subform, name].join('.');
          //     subindex = triggerThis.options.rowIdx;
          // }
          that.rowRely.buttonEvent(triggerThis.field, event);
        };
        break;
      }
      case "dept":
      case "deptgroup": {
        if (item) {
          let wi = item.widget.items;
          if (wi) {
            BsyUtils._initDeptMap(wi);
          }
        }

        config.onRelyLimit = (cb, widget) => {
          // let a = this.options;
          if (cb) {
            let ddthis = widget;
            let k = { ...widget.options.rely.data };
            k.widgetName = widget.options.widgetName;
            k.subformName = widget.options.subform;
            k.designAppId = opt.refAppId || opt.appId || window.FX.STATIC.APPID;
            k.designEntryId = opt.formId || opt.entryId;
            k.appId = opt.appId || window.FX.STATIC.APPID;
            k.entryId = opt.entryId || window.FX.STATIC.ENTRYID;
            // k.filter = that.rowRely._iterAddFilter(widget)
            let refFieldId = k.subformName
              ? [k.subformName, k.widgetName].join(".")
              : k.widgetName;
            k.filter = that.rowRely._iterAddFilter(
              that.rowRely.getFieldIndex(refFieldId, widget.options.rowIdx)
            );
            k.deptExist = true;
            if (!BsyUtils.isObjectEmpty(k.filter)) {
              window.FX.Utils.dataAjax(
                {
                  url: "/data/distinct",
                  data: k,
                },
                function (a) {
                  if (!BsyUtils.isObjectEmpty(a.items)) {
                    let limit = [];
                    BsyUtils.forEach(a.items, function (a1, b1) {
                      if (b1.hasOwnProperty("_id") || b1.hasOwnProperty("id")) {
                        limit.push(b1._id || b1.id);
                      } else {
                        limit.push(b1);
                      }
                    });
                    ddthis.options.limit = limit;
                    cb();
                  }
                }
              );
            }
          }
        };

        break;
      }
      case "user":
      case "usergroup": {
        if (item) {
          let wi = item.widget.items;
          if (wi) {
            BsyUtils._initUserMap(wi);
          }
        }

        config.onBeforeEdit = (widgetThis) => {
          let a = widgetThis.options;
          if (a.limitWidget) {
            // var
            let sub_index = null;
            if (a.limitWidget.indexOf(".") > -1) {
              sub_index = a.rowIdx;
            }
            let b = that.getWidgetByName(a.limitWidget, sub_index);
            if (b) {
              let type = b.type ? b.type : b.options.type;
              switch (type) {
                case "dept":
                case "subform_dept": {
                  let d = b.getLinkValue();
                  BsyUtils.isNull(d) ? (a.limit = []) : (a.limit = [d]);
                  break;
                }

                case "deptgroup":
                case "subform_deptgroup": {
                  let d = b.getLinkValue();
                  BsyUtils.isArray(d) ? (a.limit = d) : (a.limit = []);
                  break;
                }
                default:
              }
            }
          }
        };
        break;
      }
      default: {
        break;
      }
    }

    return config;
  };

  clearErrorMsg = () => {
    this.widgetErrorMap = {};
    if (this.element.current) {
      this.firstErrorWidget = null;
      let viewwidget = this.element.current.querySelectorAll(
        `.bsy-widget-view.error`
      );
      for (let index = 0; index < viewwidget.length; index++) {
        const element = viewwidget[index];
        element.classList.remove("error");
        let info = element.querySelector(".error-info");
        info.innerHTML = "";
      }
    }
  };

  setValue = (el) => {
    if (el.subform) {
      this.rowRely.fieldMap[el.subform.widgetName].setItemValue(el);
      this.options.resultWidgets[el.subform.widgetName].setItemValue(el);
    }
  };
  doSubmitConfirm = (ok) => {
    let opt = this.options;

    if (
      opt.ignoreOptAuth ||
      BsyUtils.isObjectEmpty(opt.confirmSettings) ||
      BsyUtils.isObjectEmpty(opt.confirmSettings.widgets)
    ) {
      //未设置直接跳过
      ok && ok();
      return;
    }

    let widgets = [];
    BsyUtils.forEach(opt.confirmSettings.widgets, function (a1, b1) {
      if (b1.indexOf(".") > -1) {
        let bb = b1.split(".");
        if (widgets.indexOf(bb[0]) == -1) {
          widgets.push(bb[0]);
        }
      }
      widgets.push(b1);
    });

    let d = opt.resultWidgets;
    this.checkRepeat = [];
    let count = 3;
    let ccindex = 0;

    let datas = [];
    let values = this.rowRely.getValue();
    for (let e in d) {
      if (widgets.indexOf(e) > -1) {
        let widget = d[e];
        if (widget && BsyUtils.isValueWidget(widget.getWidgetType())) {
          let text = values[widget.getWidgetName()];
          ccindex++;
          if (text.visible) {
            if (ccindex >= count) {
              count += 3;
            }
          }

          switch (widget.getWidgetType()) {
            case "datetime": {
              let text1 = "";
              let c = widget.options.format || "yyyy-MM-dd";

              if (!text.data) {
                text1 = "";
              } else {
                c &&
                  text &&
                  (text1 = BsyUtils.date2Str(dayjsUtils.timeToTZ(text.data), c));
              }

              if (text.visible) {
                datas.push({
                  text: widget.options.label,
                  value: text1,
                });
              }
              break;
            }
            case "number": {
              let c = widget.options.format;
              // text = BsyUtils.fixDecimalPrecision(text)
              // text && (text = BsyUtils.num2Str(text, c));
              let res = BsyUtils.numberFormatValue(
                text.data,
                widget.options || { format: c }
              );
              const afterSuffixVal = getAfterSuffix(widget.options.afterSuffix)
              if (afterSuffixVal && res.text && !res.text.includes("%")) {
                  res.text =  res.text + ' ' + afterSuffixVal;
              } 
              if (text.visible) text = res.text;
              datas.push({
                text: widget.options.label,
                value: res.text,
              });
              break;
            }
            case "signature":
            case "separator":
            case "upload":
            case "image": {
              break;
            }
            case "subform": {
              if (text.visible) {
                let subvalues = [];

                BsyUtils.forEach(text.data, (a1, b1) => {
                  let rowData = [];
                  BsyUtils.forEach(widget.options.items, (key, subwidget) => {
                    let subtext = b1[subwidget.widget.widgetName];

                    if (!subtext) {
                      subtext = {
                        data: "",
                        visible: true,
                      };
                    }

                    switch (subwidget.widget.type) {
                      case "signature":
                      case "upload":
                      case "separator":
                      case "image": {
                        break;
                      }

                      case "datetime": {
                        // let c = subwidget.options.format || "yyyy-MM-dd";
                        // c && text && (text = BsyUtils.date2Str(new Date(text), c));

                        let text1 = "";
                        let c = subwidget.widget.format || "yyyy-MM-dd";

                        if (!subtext.data) {
                          text1 = "";
                        } else {
                          c &&
                            text &&
                            (text1 = BsyUtils.date2Str(
                              dayjsUtils.timeToTZ(subtext.data),
                              c
                            ));
                        }

                        rowData.push({
                          text: subwidget.label,
                          value: text1,
                        });
                        break;
                      }
                      case "number": {
                        let c = subwidget.widget.format;
                        let res = BsyUtils.numberFormatValue(
                          subtext.data,
                          subwidget.widget || { format: c }
                        );
                        const afterSuffixVal = getAfterSuffix(subwidget.widget.afterSuffix)
                        if (afterSuffixVal && res.text && !res.text.includes("%")) {
                            res.text =  res.text + ' ' + afterSuffixVal;
                        }     
                        text = res.text;
                        rowData.push({
                          text: subwidget.label,
                          value: res.text,
                        });
                        break;
                      }
                      case "checkboxgroup":
                      case "combocheck": {
                        let text1 = subtext.data ? subtext.data.join("、") : "";
                        rowData.push({
                          text: subwidget.label,
                          value: text1,
                        });

                        break;
                      }
                      case "address":
                      case "location": {
                        let c = subwidget.widget.format || "pcda";
                        let text1 = BsyUtils.address2Str(subtext.data, c);
                        rowData.push({
                          text: subwidget.label,
                          value: text1,
                        });

                        break;
                      }
                      case "textarea": {
                        rowData.push({
                          text: subwidget.label,
                          value: subtext.data,
                        });
                        break;
                      }
                      case "dataload":
                      case "button":
                      case "linkquery": {
                        break;
                      }
                      case "user": {
                        if (subtext) {
                          if (window.userSelectMap[subtext.data]) {
                            rowData.push({
                              text: subwidget.label,
                              value: window.userSelectMap[subtext.data].name,
                            });
                          } else {
                            rowData.push({
                              text: subwidget.label,
                              value: subtext.data,
                            });
                            // window.$("<div />").text( text ).addClass("widget-text").appendTo($row);
                          }
                        } else {
                          rowData.push({
                            text: subwidget.label,
                            value: subtext.data,
                          });
                        }
                        // window.$("<div />").text(text ? text : "" ).addClass("widget-text").appendTo($row);
                        break;
                      }

                      case "dept": {
                        if (subtext) {
                          if (window.deptSelectMap[subtext.data]) {
                            rowData.push({
                              text: subwidget.label,
                              value: window.deptSelectMap[subtext.data].name,
                            });
                          } else {
                            rowData.push({
                              text: subwidget.label,
                              value: subtext.data,
                            });
                            // window.$("<div />").text( text ).addClass("widget-text").appendTo($row);
                          }
                        } else {
                          rowData.push({
                            text: subwidget.label,
                            value: subtext.data,
                          });
                        }
                        // window.$("<div />").text(text ? text : "" ).addClass("widget-text").appendTo($row);
                        break;
                      }

                      case "usergroup": {
                        if (subtext) {
                          let name = [];
                          BsyUtils.forEach(
                            subtext.data,
                            function (textindex, textdata) {
                              if (window.userSelectMap[textdata]) {
                                name.push(
                                  window.userSelectMap[textdata].name ||
                                  window.userSelectMap[textdata].nickname
                                );
                              } else {
                                name.push(textdata);
                              }
                            }
                          );
                          rowData.push({
                            text: subwidget.label,
                            value: name.join("、"),
                          });

                          // window.$("<div />").text( name.join("、") ).addClass("widget-text").appendTo($row);
                        } else {
                          rowData.push({
                            text: subwidget.label,
                            value: subtext.data,
                          });
                          // window.$("<div />").text(text ? text : "" ).addClass("widget-text").appendTo($row);
                        }
                        break;
                      }
                      case "deptgroup": {
                        if (subtext) {
                          let name = [];
                          BsyUtils.forEach(
                            subtext.data,
                            function (textindex, textdata) {
                              if (window.deptSelectMap[textdata]) {
                                name.push(window.deptSelectMap[textdata].name);
                              } else {
                                name.push(textdata);
                              }
                            }
                          );
                          rowData.push({
                            text: subwidget.label,
                            value: name.join("、"),
                          });

                          // window.$("<div />").text( name.join("、") ).addClass("widget-text").appendTo($row);
                        } else {
                          rowData.push({
                            text: subwidget.label,
                            value: subtext.data,
                          });
                          // window.$("<div />").text(text ? text : "" ).addClass("widget-text").appendTo($row);
                        }
                        break;
                      }
                      default: {
                        if (
                          subtext &&
                          subtext.data &&
                          subtext.data.hasOwnProperty("key")
                        ) {
                          rowData.push({
                            text: subwidget.label,
                            value: subtext.data.key,
                          });

                          // window.$("<div />").text(text.key ? text.key : "" ).addClass("widget-text").appendTo($row);
                        } else {
                          rowData.push({
                            text: subwidget.label,
                            value: subtext.data,
                          });
                          // window.$("<div />").text(text ? text : "" ).addClass("widget-text").appendTo($row);
                        }
                      }
                    }
                  });
                  subvalues.push(rowData);
                });
                datas.push({
                  text: widget.options.label,
                  value: subvalues,
                  type: "subform",
                });
              }
              break;
            }
            case "checkboxgroup":
            case "combocheck": {
              let text1 = text.data ? text.data.join("、") : "";
              if (text.visible)
                datas.push({
                  text: widget.options.label,
                  value: text1,
                });
              break;
            }
            case "address":
            case "location": {
              let c = widget.options.format || "pcda";
              let text1 = BsyUtils.address2Str(text.data, c);
              if (text.visible)
                datas.push({
                  text: widget.options.label,
                  value: text1,
                });
              break;
            }
            case "textarea": {
              if (text.visible)
                datas.push({
                  text: widget.options.label,
                  value: text.data,
                });
              break;
            }
            case "user": {
              if (text) {
                if (window.userSelectMap[text.data]) {
                  // window.$("<div />").text(widget.selectMap[text].name ).addClass("widget-text").appendTo($row);
                  if (text.visible)
                    datas.push({
                      text: widget.options.label,
                      value:
                        window.userSelectMap[text.data].name ||
                        window.userSelectMap[text.data].nickname,
                    });
                } else {
                  if (text.visible)
                    datas.push({
                      text: widget.options.label,
                      value: text.data,
                    });
                  // window.$("<div />").text( text ).addClass("widget-text").appendTo($row);
                }
              } else {
                if (text.visible)
                  datas.push({
                    text: widget.options.label,
                    value: text.data ? text.data : "",
                  });
              }
              // window.$("<div />").text(text ? text : "" ).addClass("widget-text").appendTo($row);
              break;
            }
            case "dept": {
              if (text) {
                if (window.deptSelectMap[text.data]) {
                  // window.$("<div />").text(widget.selectMap[text].name ).addClass("widget-text").appendTo($row);
                  if (text.visible)
                    datas.push({
                      text: widget.options.label,
                      value:
                        window.deptSelectMap[text.data].name ||
                        window.deptSelectMap[text.data].nickname,
                    });
                } else {
                  if (text.visible)
                    datas.push({
                      text: widget.options.label,
                      value: text.data,
                    });
                  // window.$("<div />").text( text ).addClass("widget-text").appendTo($row);
                }
              } else {
                if (text.visible)
                  datas.push({
                    text: widget.options.label,
                    value: text.data ? text.data : "",
                  });
              }
              // window.$("<div />").text(text ? text : "" ).addClass("widget-text").appendTo($row);
              break;
            }

            case "usergroup": {
              if (text) {
                let name = [];
                BsyUtils.forEach(text.data, function (textindex, textdata) {
                  if (window.userSelectMap[textdata]) {
                    name.push(
                      window.userSelectMap[textdata].name ||
                      window.userSelectMap[textdata].nickname
                    );
                  } else {
                    name.push(textdata);
                  }
                });
                if (text.visible)
                  datas.push({
                    text: widget.options.label,
                    value: name.join("、"),
                  });
                // window.$("<div />").text( name.join("、") ).addClass("widget-text").appendTo($row);
              } else {
                if (text.visible)
                  datas.push({
                    text: widget.options.label,
                    value: text.data ? text.data : "",
                  });
                // window.$("<div />").text(text ? text : "" ).addClass("widget-text").appendTo($row);
              }
              break;
            }
            case "deptgroup": {
              if (text) {
                let name = [];
                BsyUtils.forEach(text.data, function (textindex, textdata) {
                  if (window.deptSelectMap[textdata]) {
                    name.push(window.deptSelectMap[textdata].name);
                  } else {
                    name.push(textdata);
                  }
                });
                if (text.visible)
                  datas.push({
                    text: widget.options.label,
                    value: name.join("、"),
                  });
                // window.$("<div />").text( name.join("、") ).addClass("widget-text").appendTo($row);
              } else {
                if (text.visible)
                  datas.push({
                    text: widget.options.label,
                    value: text.data ? text.data : "",
                  });
                // window.$("<div />").text(text ? text : "" ).addClass("widget-text").appendTo($row);
              }
              break;
            }
            default: {
              if (text && text.data && text.data.hasOwnProperty("key")) {
                if (text.visible)
                  datas.push({
                    text: widget.options.label,
                    value: text.data.key ? text.data.key : "",
                  });

                // window.$("<div />").text(text.key ? text.key : "" ).addClass("widget-text").appendTo($row);
              } else {
                if (text.visible)
                  datas.push({
                    text: widget.options.label,
                    value: text.data ? text.data : "",
                  });
                // window.$("<div />").text(text ? text : "" ).addClass("widget-text").appendTo($row);
              }
            }
          }
        }
      }
    }
    if (count > 9) count = 9;
    // html.addClass("h" + count);

    // let pane = null;
    let height = 300;
    switch (count) {
      case 3: {
        height = 300;
        break;
      }
      case 6:
        height = 400;
        break;
      case 9:
        height = 500;
        break;
      default: {
      }
    }

    let renderSubformRow = (data) => {
      if (BsyUtils.isObjectEmpty(data)) {
        return "";
      }

      return (
        <div className="row">
          {" "}
          {data.map((e) => {
            return (
              <div className="widget-view subform ">
                <div className="widget-title subform">{e.text}</div>
                <div className="widget-text">{e.value}</div>
              </div>
            );
          })}
        </div>
      );
    };

    let renderSubform = (data) => {
      return (
        <>
          {" "}
          {data.map((e) => {
            return renderSubformRow(e);
          })}{" "}
        </>
      );
    };

    BsyDialog({
      title:
        opt.confirmSettings.tip ||
        React.language("form.submit.Confirm.settings.tips.4"),
      subTitle: "",
      height: height,
      width: 560,
      noFooter: true,
      onContentCreate: (e) => {
        return (
          <>
            <div className={"bsy-submit-Confirm content h" + count}>
              {datas.map((e) => {
                if (e.type === "subform") {
                  return (
                    <div className="widget-view">
                      <div className="widget-title">{e.text}</div>
                      <div className="widget-text subform">
                        {renderSubform(e.value)}
                      </div>
                    </div>
                  );
                }
                return (
                  <div className="widget-view">
                    <div className="widget-title">{e.text}</div>
                    <div className="widget-text">{e.value}</div>
                  </div>
                );
              })}
              <div className="footer">
                <BsyIconBtn
                  text={React.language("ok")}
                  click={() => {
                    ok && ok();
                    e.closeAlter();
                  }}
                  type={"blue"}
                  mode={window.mode}
                ></BsyIconBtn>
                <BsyIconBtn
                  text={React.language("cancel")}
                  click={() => {
                    e.closeAlter();
                  }}
                  mode={window.mode}
                ></BsyIconBtn>
              </div>
            </div>
          </>
        );
      },
    });
  };

  checkSubShowField = () => {
    BsyUtils.forEach(this.options.resultWidgets, (a1, b1) => {
      if (b1.options.type === "subform") {
        // b1.showField();
      }
    });
  };

  doVerifyAndSubmit = (extData) => {
    let that = this;
    let opt = this.options;
    this.firstErrorWidget = null;
    this.clearErrorMsg();
    this.extData = extData;
    if (that.setFormValueIng) {
      console.log("```````````数据加载到子表单，公式执行中```````````");
      tipAlert({
        type: "warning",
        msg: "数据加载到子表单，公式执行中",
      });
      return;
    }

    let result = true;
    if (
      opt.ignoreAuth ||
      (extData &&
        ["back", "save", "transfer", "close", "sign_before"].includes(extData.flowAction))
    ) {
      result = this.rowRely.doVerifySubformSubmit();
    } else {
      result = this.rowRely.doVerifyAndSubmit();
    }

    // (extData &&
    //   ["back", "save", "transfer", "close"].includes(extData.flowAction)) ||
    // this.rowRely.doVerifyAndSubmit()

    if (result) {
      this.getCacheValue();

      this.doSubmitConfirm(() => {
        let layerRef = null;
        BsyMaskLayer({
          customCls: "sloading",
          onContentCreate: (ref) => {
            layerRef = ref;
            that.rowRely.doSubmit(
              (res) => {
                if (res.data.msg) {
                  //给后端_form事件用  返回真的时候有提示信息也要提示 zhxj 19521
                  tipAlert({
                    type: "success",
                    msg: res.data.msg,
                  });
                }
                // //提交模式,需要清理无效的缓存数据

                if (opt.cacheEnable == 1) {
                  that.removeFormData();
                  window.FX.FORMCACHE = null;
                  window.$(window).off("unload");
                }

                // //保留最新的缓存数据
                opt.cacheEnable == 2 && that.saveFormData();

                BsyUtils.applyFunc(
                  that,
                  that.props.onSuccess,
                  [
                    {
                      data: res.data,
                      flowAction: that.flowAction,
                      needPrint: that.needPrint,
                      values: this.getCacheValue(),
                    },
                    null,
                    that,
                  ],
                  !1
                );
                window.FX.FORMCACHE = null;
                layerRef && layerRef.close();
                that.checkSubShowField();
              },
              (res) => {
                let d = res.data || {};
                if (d.error_code) {
                  //重置子表单的ID
                  if (opt.mode === "new") that.regenerationSubformId();

                  BsyUtils.applyFunc(
                    that,
                    that.props.onError,
                    [
                      {
                        data: res.data,
                        flowAction: that.flowAction,
                        needPrint: that.needPrint,
                        values: this.getCacheValue(),
                      },
                      null,
                      that,
                    ],
                    !1
                  );
                }

                if (d.code > 7100) {
                  // BsyUtils.Vip.showUpgradeTip(d);
                } else {
                  switch (d.code) {
                    case 4002: {
                      let lables = [];
                      if (d.meta) {
                        BsyUtils.forEach(d.meta.repeatFields, function (a, c) {
                          let str = BsyUtils.stringSlice(that.labelMap[c], 15);
                          lables.push(`「${str}」`);
                          if (BsyUtils.isSubformWidget(c)) {
                            let sub = c.split(".");
                            let error = that.widgetErrorMap[sub[0]];
                            if (error) {
                              error.errs[sub[1]] = d.meta.repeatFieldsData[c];
                            } else {
                              error = {
                                name: sub[0],
                                errs: {
                                  [sub[1]]: d.meta.repeatFieldsData[c],
                                },
                                errMsg: React.language("form.submit.repeat"),
                              };
                            }
                            that.widgetErrorMap[error.name] = { ...error };
                          } else {
                            let error = {
                              name: c,
                              // errs: errorWidgets,
                              errMsg: React.language("form.submit.repeat"),
                            };
                            that.widgetErrorMap[error.name] = { ...error };
                          }

                          // if(c.indexOf(".") != -1){
                          //     let sub=b.getWidgetByName(c);
                          //     sub && FX.Utils.forEach(sub,function(subk,subv){
                          //         let subvalue=subv.getValue();
                          //         if(da.meta.repeatFieldsData[c] && da.meta.repeatFieldsData[c].indexOf(subvalue) > -1){
                          //             b._addSubErrorBorder(subv);
                          //         }
                          //     })
                          //     let cstr = c.split('.');
                          //     let d = b.getWidgetByName(cstr[0]);
                          // }else{
                          //     let d = b.getWidgetByName(c);
                          // }
                          // d && b.setErrorState(d, React.language("form.submit.repeat"))
                        });
                        lables = BsyUtils.arrayUnique(lables);
                        tipAlert({
                          type: "error",
                          msg: `${React.language("field")}：${lables.join(
                            "、"
                          )}，${d.msg}`,
                        });
                      } else {
                        tipAlert({
                          type: "error",
                          msg: d.msg,
                        });
                      }
                      break;
                    }
                    case 3333: {
                      // b.options.onError ? FX.Utils.applyFunc(b, b.options.onError,[d],!1) :
                      // tipAlert({
                      //     type: "error",
                      //     msg: e
                      // })

                      break;
                    }
                    default: {
                      // tipAlert({
                      //     type: "error",
                      //     msg: e
                      // })
                    }
                  }
                  if (d.ret) {
                    const triggerControl = d.ret.result.triggerControl;
                    const triggerWidget = d.ret.result.triggerWidget;
                    that.rowRely._setEventResult(d.ret, -1);
                    if (triggerControl) {
                      that.rowRely.dealRelys([triggerControl]);
                      // that.fireFixedRely([that.triggerControl])
                    }

                    if (triggerWidget) {
                      that.rowRely.fireFixedRely([triggerWidget]);
                    }
                    that.rowRely.getViewVisibleMap();
                    that.setWidgetVisible && that.setWidgetVisible(null, true);
                  }
                  layerRef && layerRef.close();
                  BsyUtils.forEach(that.widgetErrorMap, (k, v) => {
                    let widget = that.getWidgetByName(k);

                    if (widget.getWidgetType() === "subform") {
                      widget.setError(v);
                    }
                    that.setWidgetError(v);
                  });
                  that.checkSubShowField();
                }
              },
              extData
            );
            return <BsySLoading />;
          },
        });
      });
    } else {
      this.scrollInvalidWidgetToView();
      this.setCacheValue();
    }
  };

  _getWidgetOptAuth = (b) => {
    if (b.widget.widgetName === "_widget_1664333185903") {
      console.log("_widget_1664333185903", b.widget.widgetName);
    }
    let c = this.options,
      d = this;
    //为了解决权限中 新建 不受字段可编辑影响修改 zhxj190606
    if (c.ignoreOptAuth) {
      return {
        ignoreOptAuth: !0,
        visible: true,
        enable: true,
      };
    } else {
      //2020 02 14 bobo 任何场景，只要是新建数据，可见可编辑只走设计界面/流程表走流程节点
      if (c.mode === "new" || c.mode === "copy") {
        return {};
      } else {
        //2020 07 02 数据内链的编辑权限处理
        if (c.hasDataViewLink) {
          if ("subform" === b.widget.type) {
            BsyUtils.forEach(b.widget.items, function (c, e) {
              e.widget = {
                ...e.widget,
                ...d._getWidgetOptAuth({
                  widget: {
                    widgetName: [b.widget.widgetName, e.widget.widgetName].join(
                      "."
                    ),
                  },
                }),
              };
            });
          }
          if (c.widgetOptAuth && c.widgetOptAuth[b.widget.widgetName]) {
            return c.widgetOptAuth[b.widget.widgetName];
          } else {
            return {
              visible: !1,
              enable: !1,
            };
          }
        } else {
          if (c.flow || !BsyUtils.isNull(c.authGroupId)) {
            if ("subform" === b.widget.type) {
              BsyUtils.forEach(b.widget.items, function (c, e) {
                e.widget = {
                  ...e.widget,
                  ...d._getWidgetOptAuth({
                    widget: {
                      widgetName: [
                        b.widget.widgetName,
                        e.widget.widgetName,
                      ].join("."),
                    },
                  }),
                };
              });
            }

            if (c.widgetOptAuth && c.widgetOptAuth[b.widget.widgetName]) {
              //新建的不受权限组里的编辑权限控制 受表单设计处理
              let ret = { ...c.widgetOptAuth[b.widget.widgetName] }; //不能直接等于 要不原始值又被改变了
              if (c.mode === "new") {

                delete ret.enable;
                if ("subform" === b.widget.type) {
                  delete ret.subform_create;
                  delete ret.subform_insert;
                  delete ret.subform_delete;
                  delete ret.subform_edit;
                  delete ret.subform_import;
                  delete ret.subform_dataload;
                }
                return ret;
              } else {

                if ("subform" === b.widget.type) {
                  // delete ret.subform_create;
                  // delete ret.subform_insert;
                  // delete ret.subform_delete;
                  // delete ret.subform_edit;
                  return {
                    ...ret,
                    subform_create: ret.hasOwnProperty("subform_create") ? ret.subform_create : true,
                    subform_insert: ret.hasOwnProperty("subform_insert") ? ret.subform_insert : true,
                    subform_delete: ret.hasOwnProperty("subform_delete") ? ret.subform_delete : true,
                    subform_edit: ret.hasOwnProperty("subform_edit") ? ret.subform_edit : true,
                    subform_import: ret.hasOwnProperty("subform_import") ? ret.subform_import : true,
                    subform_dataload: ret.hasOwnProperty("subform_dataload") ? ret.subform_dataload : true,
                  }
                } else
                  return c.widgetOptAuth[b.widget.widgetName];
              }
            } else {
              return {
                visible: !1,
                enable: !1,
              };
            }
          } else {
            return {};
          }
        }
      }
    }
  };

  getlayoutMode = (c) => {
    let e = this.options;
    if (!e.pcLayout) {
      return null;
    }

    return {
      description:
        e.pcLayout.description && !e.pcLayout.description.visible
          ? "no-description"
          : "",
      inputWidth:
        e.pcLayout.input &&
          e.pcLayout.input.width === "auto" &&
          e.formLayout !== "normal" &&
          e.formLayout !== "grid-1"
          ? "auto-width"
          : "",
      layout:
        e.pcLayout.label &&
          e.pcLayout.label.layout === "horizontal" &&
          BsyUtils.isSupportHorizontalLayout(c.type)
          ? "layout-horizontal"
          : "",
      labelTextAlign:
        e.pcLayout.label &&
          e.pcLayout.label.layout === "horizontal" &&
          BsyUtils.isSupportHorizontalLayout(c.type) &&
          e.pcLayout.label &&
          e.pcLayout.label.textAlign === "right"
          ? "textAlign-right"
          : "",
      layoutWidth:
        e.pcLayout.label &&
          e.pcLayout.label.layout === "horizontal" &&
          BsyUtils.isSupportHorizontalLayout(c.type)
          ? e.pcLayout.label.width
          : "",
    };
  };

  createItem = (item, selectTab) => {
    const { cacheValue, widgetErrorMap } = this;
    const { showRules } = this.state;
    let e = this.options;
    let { items, is_dock_form, dataId } = e;
    const { widgetName } = item;
    let authItems = {};
    items.map(
      (res) => res.widget.widgetName === item.widgetName && (authItems = res)
    );
    let that = this;

    let layoutMode = that.getlayoutMode(item);

    let cls = "";
    if (layoutMode) {
      cls += layoutMode.description ? ` ${layoutMode.description} ` : "";
      cls += layoutMode.inputWidth ? ` ${layoutMode.inputWidth} ` : "";
      cls += layoutMode.layout ? ` ${layoutMode.layout} ` : "";
      cls += layoutMode.labelTextAlign ? ` ${layoutMode.labelTextAlign} ` : "";
    }
    let auth = this._getWidgetOptAuth(authItems);
    let config = {
      ...item,
      ...auth,
      dataId,
      items: this.formFieldsAttr[widgetName].items,
      is_dock_form: is_dock_form,
    };

    let visible = this.formFieldsAttr[widgetName].visible;
    let enable = this.formFieldsAttr[widgetName].enable;
    //权限组为不可见时，不走显隐规则
    if (visible) {
      if (!BsyUtils.isObjectEmpty(showRules)) {
        if (showRules.hasOwnProperty(widgetName)) {
          visible = showRules[widgetName];
        }
        //隐藏标签页中的元素
        if (config.tab && showRules[config.tab] && visible) {
          visible = showRules[config.tab];
        }
      }
    }

    if (cacheValue.hasOwnProperty(config.widgetName)) {
      config.value = cacheValue[config.widgetName];
    }
    let error = null;
    if (widgetErrorMap[config.widgetName]) {
      error = widgetErrorMap[config.widgetName];
    }

    if (config.type === "subform") {
      config.widgetErrorMap = error;
      config = { ...config, ...this.formFieldsAttr[widgetName] };
    }

    // 后端返回值的权限，可以强制改变所有的显示隐藏属性
    if (this.formFieldsAttr[widgetName].hasOwnProperty("eventVisible")) {
      visible = this.formFieldsAttr[widgetName].eventVisible;
    }
    if (this.formFieldsAttr[widgetName].hasOwnProperty("eventEnable")) {
      enable = this.formFieldsAttr[widgetName].eventEnable;
    }
    config = {
      ...config,
      enable: enable,
      visible: visible,
    };
    if (!e.ignoreOptAuth) {
      if (visible === false) {
        // console.log("--- 111 bsy-ui-hidden ---");
        cls += " bsy-ui-hidden ";
      }
    } else {
      config = {
        ...config,
        enable: true,
        visible: true,
      };
    }
    if (!this.firstErrorWidget) {
      this.firstErrorWidget = error;
    }

    let wcls =
      `bsy-widget-view view-${config.widgetName} x-grid-col-${config.lineWidth} ${cls} ` +
      (error ? "error" : "") +
      " " +
      (item.tab ? (selectTab === item.tab ? item.tab : item.tab + " hide") : "");
    // console.log('createItem:', config.labelStyle || config.label, wcls)

    let description = "";
    if (config.type === "separator") {
      description = window.FX.Utils.replaceDescription(config.value);
      config.value = description;
      description = "";
    } else {
      description = window.FX.Utils.replaceDescription(config.description);
    }

    let descriptionStyles = "";
    if (
      !(
        e.pcLayout &&
        e.pcLayout.label &&
        e.pcLayout.label.layout === "horizontal" &&
        e.pcLayout.description &&
        !e.pcLayout.description.visible
      ) &&
      description
    ) {
    } else {
      descriptionStyles = "none";
    }
    // console.log(wcls);
    return (
      <li className={wcls} key={item.widgetName}>
        <div
          className="fl-label"
          style={{
            width: layoutMode ? layoutMode.layoutWidth : "",
            display:
              config.type === "separator" &&
                ["style1", "style3", "style4", "style5"].includes(
                  config.lineStyle
                )
                ? "none"
                : "",
          }}
        >
          {config.allowBlank === false ? (
            <span className="label-notnull">*</span>
          ) : (
            ""
          )}

          {config.labelHidden === true ? (
            <span className="label-title"></span>
          ) : (
            <span
              className="label-title"
              style={{
                color: config.type === "separator" ? config.labelColor : "",
              }}
              dangerouslySetInnerHTML={{
                __html: config.labelStyle || config.label,
              }}
            ></span>
          )}

          {description &&
            e.pcLayout &&
            e.pcLayout.label &&
            e.pcLayout.label.layout === "horizontal" &&
            e.pcLayout.description &&
            !e.pcLayout.description.visible ? (
            <div
              className="description-info"
              onMouseEnter={(event) => {
                if (description && window.FX && window.FX.UI) {
                  window.FX.UI.showPopover({
                    position: "bottomLeft",
                    anchor: window.$(event.target),
                    content: window.$("<span/>").html(description),
                    type: "dark",
                  });
                }
              }}
              onMouseLeave={() => {
                if (description && window.FX && window.FX.UI) {
                  window.FX.UI.closePopover();
                }
              }}
            >
              <i className="icon-bby-new-tip"></i>
            </div>
          ) : (
            ""
          )}
        </div>
        <div className="fl-container">
          <div
            className="fl-description"
            dangerouslySetInnerHTML={{ __html: description }}
            style={{ display: descriptionStyles }}
          ></div>
          <div className="fl-widget">
            {" "}
            {BsyUtils.createWidget({ ...config, visible: visible })}
            {
              // error ?
              <div className="error-info">{error ? error.errMsg : ""}</div>
              // : ''
            }
          </div>
        </div>
      </li>
    );
  };

  clearWidgetError = () => {
    if (!this.element.current) {
      return;
    }
    //清空所有错误
    let viewwidget = this.element.current.querySelectorAll(
      `.bsy-widget-view.error`
    );
    BsyUtils.forEach(viewwidget, (i, viewwidget) => {
      viewwidget.classList.remove("error");
      let errorEl = viewwidget.querySelector(".error-info");
      errorEl.innerHTML = "";
    });
    BsyUtils.forEach(this.options.resultWidgets, (a1, b1) => {
      if (b1.options.type === "subform") {
        b1.setError({});
      }
    });
    let subcell = this.element.current.querySelectorAll(
      ".bsy-subform .sub-cell.error"
    );
    BsyUtils.forEach(subcell, (si, sviewwidget) => {
      sviewwidget.classList.remove("error");
    });
  };

  setWidgetError(error) {
    let viewwidget = this.element.current.querySelector(`.view-${error.name}`);
    if (viewwidget) {
      viewwidget.classList.add("error");
      let errorEl = viewwidget.querySelector(".error-info");
      if (errorEl) {
        if (error.type === "subform") {
          if (error.errMsg) {
            errorEl.innerHTML = error.errMsg;
          } else {
            if (!BsyUtils.isObjectEmpty(error.errs))
              errorEl.innerHTML = error.errs[0].errMsg;
          }
        } else {
          errorEl.innerHTML = error.errMsg;
        }
      }
    }
    if (error.type === "subform") {
      let widget = this.getWidgetByName(error.name);
      if (widget.setError) {
        widget.setError(error);
      }
    }
  }

  setLableConfig = (widget, opt) => {
    let { items } = this;

    let viewwidget = this.element.current.querySelector(`.view-${widget}`);
    if (viewwidget) {
      if (opt.hasOwnProperty("description")) {
        let description = viewwidget.querySelector(".fl-description");
        if (description) {
          description.innerHTML = opt.description;
          description.style.display = opt.description ? "" : "none";
        }
      }
      if (opt.hasOwnProperty("label")) {
        let title = viewwidget.querySelector(".label-title");
        if (title) {
          title.innerHTML = opt.label;
        }
      }
    }
  };

  setSubConfig = (widget, opt) => {
    if (this.options.resultWidgets[widget]) {
      if (opt.hasOwnProperty("itemsenable")) {
        this.options.resultWidgets[widget].itemsenable = opt.itemsenable;
      }
      if (opt.hasOwnProperty("itemslabel")) {
        this.options.resultWidgets[widget].itemslabel = opt.itemslabel;
      }
      if (opt.hasOwnProperty("itemsvisible")) {
        this.options.resultWidgets[widget].itemsvisible = opt.itemsvisible;
      }
    }
  };

  delWidgetError(error) {
    let viewwidget = this.element.current.querySelector(`.view-${error.name}`);
    if (viewwidget) {
      viewwidget.classList.remove("error");
      let error = viewwidget.querySelector(".error-info");
      if (error) {
        error.innerHTML = "";
      }
    }
  }

  scrollInvalidWidgetToView = () => {
    const { firstErrorWidget } = this;
    // console.log(widgetErrorMap)
    if (!firstErrorWidget || !firstErrorWidget.name) {
      return;
    }

    let t = this.getWidgetByName(firstErrorWidget.name);
    let viewwidget = this.element.current.querySelector(
      `.view-${firstErrorWidget.name}`
    );

    let r = this.wrapper.current;
    let n = null;
    if (viewwidget && r) {
      let e = viewwidget;

      if (this.multiTab && this.multiTab.current && t.options.tab) {
        this.multiTab.current.setActiveTabName(t.options.tab);
      }

      let a = e.offsetHeight;
      n = 0.5 * r.offsetHeight - 0.5 * a - BsyUtils.getDomOffset(e, r).top;
      r.scrollTop -= n;
      "subform" === t.getWidgetType() && t.scrollInvalidWidgetToView();
    }
  };

  _createFlowStatePane = () => {
    let b = this.options,
      c = this;
    if (c.showFlowChart) {
      return;
    }
    let data = b.editValue;
    let chargers = [];
    BsyUtils.forEach(data.chargers, function (a1, b1) {
      chargers.push(b1.userId || b1);
    });
    c.showFlowChart = true;
    this.flowStatePane = new window.FX.FlowStatePane({
      renderEl: window
        .$("<div class='flow-state' />")
        .css("z-index", window.FX.STATIC.zIndex++)
        .appendTo(window.$(c.element.current)),
      appId: b.appId || window.FX.STATIC.APPID,
      entryId: b.entryId || b.entryId,
      formId: b.formId || b.entryId,
      refAppId: b.refAppId,
      width: 780,
      dataId: data._id,
      flow: {
        flowStack: data.flowStack,
        flowState: data.flowState,
        hasLogView: !0,
        dataId: data._id,
        chargers: data.chargers,
        version: data.flowVer,
      },
      hasTransfer: b.ignoreVisible,
      flow_activate: b.flow_activate !== !1,
      flow_transfer: b.flow_transfer !== !1,
      flow_close: b.flow_close !== !1,
      logs: this.state.logs,
      hasClose: !0,
      hasTitle: !0,
      popupFormPath: b.popupFormPath,
      onClose: function () {
        c.showFlowChart = false;
      },
    });
  };
  openQrcode = (event) => {
    event.stopPropagation();

    const pot = event.currentTarget.getBoundingClientRect();
    const css =
      160 >
        document.documentElement.clientHeight -
        pot.top +
        event.currentTarget.offsetHeight +
        2
        ? {
          left: pot.left - 160 + "px",
          minWidth: event.currentTarget.offsetWidth,
          bottom: document.documentElement.clientHeight - pot.top + 2 + "px",
        }
        : {
          left: pot.left - 160 + "px",
          minWidth: event.currentTarget.offsetWidth,
          top: pot.top + event.currentTarget.offsetHeight + 2 + "px",
        };
    BsyAlertQrcode({
      value: window.location.href, //value参数为生成二维码的链接
      size: 160, //二维码的宽高尺寸
      css: css,

      text: React.language("msg.qrCode"),
      fgColor: "#000000",
    });
  };

  renderHeader = () => {
    const { name, title, formTheme, hasFlow, hasLogView, ignoreOptAuth } =
      this.options;

    if (window.FX.STATIC.FTOKEN && !BsyUtils.isObjectEmpty(formTheme)) {
      const { mode, system, custom } = formTheme;
      let sc = BsyConfig().THEME.EXTERNAL_FORM_THEME[system];
      if (mode != "system") {
        sc = { ...sc, ...custom };
      }
      let l = sc.title;
      let d = BsyConfig().THEME.DEFAULT_FORM_THEME.title;

      return (
        <div className="form-head">
          <div
            className="head-banner"
            style={{
              background:
                sc.banner.mode === "image" ? "transparent" : sc.banner.color,
            }}
          >
            {sc.banner.mode === "image" ? (
              <img style={{ width: "100%" }} src={sc.banner.image} alt="" />
            ) : (
              ""
            )}
          </div>
          <div
            className="head-title"
            style={{
              color: sc.title.color,
              "font-size": l["font-size"] || d["font-size"],
              background:
                sc.banner.mode === "image" ? "#ffffff" : l["background-color"],
              display: l["display"] || d["display"],
              "text-align": l["text-align"] || d["text-align"],
              "text-decoration": l["text-decoration"]
                ? l["text-decoration"].join("")
                : "",
              "font-style": l["font-style"] || d["font-style"],
              "font-weight": l["font-weight"] || d["font-weight"],
            }}
          >
            {name || title}
          </div>
        </div>
      );
    }

    return (
      <div className="bsy-header" style={{ minHeight: 50, lineHeight: "50px" }}>
        <span className="title">{name || title}</span>
        {this.props.isLink ? (
          <div className="view-qrcode" onClick={this.openQrcode}>
            <i className="icon-qrcode"></i>
          </div>
        ) : (
          ""
        )}
        <span
          className="all"
          onClick={(e) => {
            this.isFull = this.isFull == "true" ? "false" : "true";
            this.setfullscreenStatus(this.isFull);
            let i1 = e.currentTarget.querySelector("i");

            let parent = BsyUtils.closestClass(
              e.currentTarget,
              "bsy-form-pane"
            );
            let parent1 = BsyUtils.closestClass(
              e.currentTarget,
              "bsy-form-edit-pane"
            );
            i1.className = "";
            if (this.isFull == "true") {
              if (parent) parent.style.width = "100%";

              if (parent1) parent1.style.width = "100%";

              i1.classList.add("icon-bby-collapse");
            } else {
              if (parent) parent.style.width = "80%";
              if (parent1) {
                if (parent) parent.style.width = "100%";
                parent1.style.width = "80%";
              }
              i1.classList.add("icon-bby-expansion");
            }
          }}
        >
          {" "}
          <i className="icon-bby-expansion"></i>
        </span>

        {!window.FX.STATIC.TOKEN || ignoreOptAuth ? (
          <>
            {!window.FX.STATIC.TOKEN && hasLogView && hasFlow ? (
              <div
                className="flow-chart"
                onClick={() => {
                  this._createFlowStatePane();
                }}
              >
                <i className="icon-form-flow"> </i>
                <span>{React.language("field.flow.chart")}</span>
              </div>
            ) : (
              ""
            )}
          </>
        ) : (
          ""
        )}
        {this.props.onClose ? (
          <i
            className="icon-close-large form-exit-icon"
            onClick={() => {
              this.saveFormData();
              this.props.onClose && this.props.onClose();
            }}
          ></i>
        ) : (
          ""
        )}
      </div>
    );
  };

  _checkflowComment = (cb) => {
    const { flow } = this.options;
    let val = {};
    if (
      this.flowAction === "save" &&
      !!this.commentContext &&
      !!this.commentContext.getValue()
    ) {
      const _this = this;
      BsyAlert({
        title: React.language("form.comment.save"),
        msg: React.language("form.comment.save.desc"),
        type: "warning",
        text4Ok: React.language("form.comment.copy"),
        ok: function () {
          BsyUtils.copyToClipboard(
            _this.commentContext.getValue(),
            function () {
              if (_this.commentContext)
                val.comment = _this.commentContext.getValue();
              if (_this.signatureContext)
                val.signature = _this.signatureContext.getValue();
              tipAlert({
                type: "success",
                msg: React.language("form.comment.copied"),
              });
            }
          );
          cb && cb(val);
        },
        onCancel: function () { },
      });
      return;
    }
    if (this.flowAction !== "save" && flow.comment && flow.comment.enable) {
      if (!this.commentContext.checkValidate() && flow.comment.required) {
        tipAlert({
          type: "warning",
          msg: React.language("form.comment.notNull"),
        });
        return false;
      }
      val.comment = this.commentContext.getValue();
    }
    if (this.flowAction !== "save" && flow.signature && flow.signature.enable) {
      if (!this.signatureContext.checkValidate()) {
        tipAlert({
          type: "warning",
          msg: React.language("form.comment.notNull.signature"),
        });
        return false;
      }
      val.signature = this.signatureContext.getValue();
    }

    return val;
  };

  _switchBackNode = (flowId, callback) => {
    let d = this.options;

    window.FX.Utils.dataAjax(
      {
        url: "/data/allow_back_nodes",
        data: {
          appId: d.appId || window.FX.STATIC.APPID,
          entryId: d.entryId,
          formId: d.formId || d.entryId,
          dataId: d.dataId,
          flowId: flowId,
        },
      },
      function (data) {
        if (data.data.length == 0) {
          callback();
        } else {
          let items = [];
          data.data.map((e) => {
            items.push({
              text: e.name,
              value: e.flowId,
            });
          });
          let id = "";
          BsyDialog({
            title: React.language("flow.action.back"),
            subTitle: "",
            height: 400,
            width: 400,
            noFooter: true,
            onContentCreate: (e) => {
              return (
                <>
                  <div className={"bsy-back-node-list "}>
                    <div className="title">
                      {React.language("flow.node.select")}
                    </div>
                    <BsyRadioGroup
                      layout={"vertical"}
                      items={items}
                      onStopEdit={(e) => {
                        id = e;
                      }}
                    ></BsyRadioGroup>
                    <div className="footer">
                      <BsyIconBtn
                        text={React.language("ok")}
                        click={() => {
                          if (id === "") {
                            tipAlert({
                              type: "warning",
                              msg: React.language("flow.back.node.select"),
                            });
                            return;
                          }
                          callback([id]);
                          e.closeAlter();
                        }}
                        type={"blue"}
                        mode={window.mode}
                      ></BsyIconBtn>
                      <BsyIconBtn
                        text={React.language("cancel")}
                        click={() => {
                          e.closeAlter();
                        }}
                        mode={window.mode}
                      ></BsyIconBtn>
                    </div>
                  </div>
                </>
              );
            },
          });
        }
      },
      null,
      function () { }
    );
  };

  _switchTransferChargers = (callback) => {
    let c = this,
      d = this.options;
    let flow = d.flow;
    if (flow.candidates && flow.candidates.limitWidget) {
      flow.candidates.limit = {
        creator: 0,
        departs: [],
        deptManager: 0,
        deptMgrWidgets: [],
        deptWidgets: [],
        deptcurrentsubdept: 0,
        nodeCharge: 0,
        public: [],
        roles: [],
        users: [],
        widgets: [],
      };
      if (d.resultWidgets[flow.candidates.limitWidget]) {
        let v = d.resultWidgets[flow.candidates.limitWidget].getValue();
        if (
          d.resultWidgets[flow.candidates.limitWidget].options.type === "dept"
        ) {
          if (v) {
            flow.candidates.limit.departs = [v];
          }
        } else {
          flow.candidates.limit.departs = v;
        }
      }
    }

    let o = new window.FX.ConfirmDialog({
      title: React.language("subform.data.load.tip9"),
      height: 589,
      width: 600,
      onOk: function () {
        let e = o.getWidgetByName("select_transfer_user");
        c.candidateId = e.getValue();
        if (c.candidateId) {
          callback(c.candidateId);
          o.close();
        } else {
          tipAlert({
            type: "warning",
            msg: React.language("empty.report.tip25"),
          });
        }
      },
      contentWidget: {
        rowSize: [450],
        colSize: [570],
        padding: 15,
        items: [
          [
            {
              widgetName: "select_transfer_user",
              type: "transferdeptuser",
              limit: flow.candidates ? flow.candidates.limit : {},
              entryId: d.entryId,
              formId: d.formId || d.entryId,
              dataId: d.dataId,
              appId: d.appId,
            },
          ],
        ],
      },
    });
    o.show();
  };

  _submitSign = (callback) => {
    BsyDialog({
      title: React.language("flow.sign.pane"),
      height: 380,
      width: 540,
      noFooter: true,
      onContentCreate: (ref) => {
        return (
          <SingPage
            allowSignTypes={this.options.allowSignTypes}
            is_dock_form={this.options.is_dock_form}
            onStopEdit={(signValue) => {
              callback(signValue);
              ref.closeAlter();
            }}
            onClose={() => {
              ref.closeAlter();
            }}
          ></SingPage>
        );
      },
    });
  };

  submitHandler = (type) => {
    const { flowType, flowId } = this.options;
    this.needPrint = false;
    switch (type) {
      case "print": {
        this.needPrint = !0;
        let comment = this._checkflowComment();
        if (!comment) {
          return;
        }
        this.flowAction = "forward";
        this.doVerifyAndSubmit({
          ...comment,
          flowAction: this.flowAction,
          flowId: flowId,
          flowType: flowType,
        });
        break;
      }
      case "save":
        this.flowAction = type;
        let comment = this._checkflowComment((comment) => {
          this.doVerifyAndSubmit({
            ...comment,
            flowAction: this.flowAction,
            flowId: flowId,
            flowType: flowType,
          });
        });
        if (!comment) {
          return;
        }
        this.doVerifyAndSubmit({
          ...comment,
          flowAction: this.flowAction,
          flowId: flowId,
          flowType: flowType,
        });
        break;
      case "forward": {
        this.flowAction = type;
        let comment = this._checkflowComment();
        if (!comment) {
          return;
        }
        this.doVerifyAndSubmit({
          ...comment,
          flowAction: this.flowAction,
          flowId: flowId,
          flowType: flowType,
        });

        break;
      }
      case "back": {
        this.flowAction = "back";
        let comment = this._checkflowComment();
        if (!comment) {
          return;
        }
        this._switchBackNode(flowId, (e) => {
          this.doVerifyAndSubmit({
            ...comment,
            flowAction: this.flowAction,
            flowId: flowId,
            flowType: flowType,
            backnode: e,
          });
        });
        break;
      }
      case "sign": {
        let comment = this._checkflowComment();
        if (!comment) {
          return;
        }
        this.flowAction = "sign";
        this._submitSign((signValue) => {
          this.doVerifyAndSubmit({
            ...comment,
            flowAction: this.flowAction,
            flowId: flowId,
            flowType: flowType,
            ...signValue,
          });
        });
        break;
      }
      case "transfer": {
        this.flowAction = "transfer";
        let comment = this._checkflowComment();
        if (!comment) {
          return;
        }
        this._switchTransferChargers((candidateId) => {
          this.doVerifyAndSubmit({
            ...comment,
            flowAction: this.flowAction,
            flowId: flowId,
            flowType: flowType,
            candidateId: candidateId,
          });
        });
        break;
      }
      case "revoke": {
        this.flowAction = "revoke";
        this.doVerifyAndSubmit({
          flowAction: this.flowAction,
          flowId: flowId,
          flowType: flowType,
        });

        break;
      }
      case "close": {
        let comment = this._checkflowComment();
        if (!comment) {
          return;
        }

        this.flowAction = "close";
        this.doVerifyAndSubmit({
          ...comment,
          flowAction: this.flowAction,
          flowId: flowId,
          flowType: flowType,
        });
        break;
      }
      default: {
      }
    }
  };

  getFormDataKey = () => {
    let t = this.options;
    return BsyUtils.Store.getKey("formData", {
      appId: t.appId,
      entryId: t.entryId,
      formId: t.formId || t.entryId,
    });
  };
  removeFormData = () => {
    BsyUtils.Store.remove(this.getFormDataKey());
  };
  loadFormData = () => {
    let _this = this;
    let t = this.options;

    if (t.cacheEnable) {
      _this._bindCacheEvent();
      let e = BsyUtils.Store.get(_this.getFormDataKey());

      if (e && e.data) {
        let widgetMap = {};

        BsyUtils.forEach(e.data, function (a1, b1) {
          let widget = t.resultWidgets[a1];
          if (!widget) {
            return;
          }
          let type = widget.getWidgetType();
          if (["upload", "image", "signature", "subform"].indexOf(type) != -1) {
            if (type === "subform") {
              widgetMap[a1] = [];
              let n = b1.length;
              for (let i = 0; i < n; i++) {
                let subrowdata = {};
                b1[i] && b1[i].hasOwnProperty("id") && delete b1[i].id;
                BsyUtils.forEach(b1[i], function (a2, b2) {
                  if (["upload", "image"].indexOf(b2.widgetType) != -1) {
                    subrowdata[a2] = b2;
                  }
                });
                widgetMap[a1].push(subrowdata);
              }
            } else {
              // b1[0].qnKey += "112233"
              widgetMap[a1] = b1;
            }
          }
        });

        _this.cacheWidgetMap = widgetMap;

        _this._checkFile(widgetMap, function (map) {
          //把请求后的值还原
          BsyUtils.forEach(e.data, function (a1, b1) {
            let widget = t.resultWidgets[a1];
            if (!widget) {
              return;
            }
            let type = widget.getWidgetType();
            if (
              ["upload", "image", "signature", "subform"].indexOf(type) != -1
            ) {
              if (type === "subform") {
                if (map[a1]) {
                  let n = b1.length;
                  for (let i = 0; i < n; i++) {
                    BsyUtils.forEach(b1[i], function (a2) {
                      if (map[a1][i][a2]) {
                        e.data[a1][i][a2] = map[a1][i][a2];
                      }
                    });
                  }
                }
              } else {
                if (map[a1]) {
                  e.data[a1] = map[a1];
                }
              }
            }
          });

          if (e && e.data) {
            BsyUtils.forEach(t.resultWidgets, function (t, i) {
              let a = e.data[t];
              if (a !== "" && !BsyUtils.isObjectEmpty(a)) {
                if (
                  !(
                    !i ||
                    BsyConfig().LimitFields.noCache.indexOf(i.getWidgetType()) >
                    -1
                  )
                ) {
                  i.field.setValue(a);
                  if (i.effectItemLinkWidgets) i.effectItemLinkWidgets();
                }
                // !i || FX.LimitFields.noCache.indexOf(i.getWidgetType()) > -1 || (i.setValue(a),
                //     i.effectItemLinkWidgets && i.effectItemLinkWidgets())
              }
            });
            _this._setLinkQuery();
            _this.needCache = !0;
          }

          // e && e.data && (BsyUtils.forEach(t.resultWidgets, function(t, i) {

          //     // if(_opt.cacheAllField || _opt.cacheFields.indexOf(i.options.widgetName) > -1 )
          //     {
          //         let a = e.data[t];
          //         if(a !== "" &&  !FX.Utils.isObjectEmpty(a))
          //         {
          //             !i || FX.LimitFields.noCache.indexOf(i.getWidgetType()) > -1 || (i.setValue(a),
          //             i.effectItemLinkWidgets && i.effectItemLinkWidgets())
          //         }
          //     }
          // }),
          // _this._setLinkQuery(),
          // _this.needCache = !0);
        });
      }
      // if(_opt.cacheEnable == 1)
      //     _this.removeFormData()
    }
  };
  saveFormData = () => {
    let e = this.options;
    let _opt = this.options;

    if (this._isEditMode()) return;
    // console.log('-------------------saveFormData-------------------------')

    if (e.cacheEnable) {
      let i = {},
        a1 = e.resultWidgets;
      e.updateTime = Date.parse(new Date());
      BsyUtils.forEach(a1, function (t, e) {
        if (
          e &&
          BsyUtils.isValueWidget(e.getWidgetType()) &&
          !(BsyConfig().LimitFields.noCache.indexOf(e.getWidgetType()) > -1)
        ) {
          let a1 = e.getValue();
          if (_opt.cacheAllField) {
            if (a1 !== "" && !BsyUtils.isObjectEmpty(a1)) {
              i[t] = a1;
            }
          } else {
            if (e.getWidgetType() === "subform") {
              let subtmpdata = [];
              BsyUtils.forEach(a1, function (i, subval) {
                let tmp = {};
                BsyUtils.forEach(subval, function (ii, val) {
                  if (
                    _opt.cacheFields.indexOf(e.options.widgetName + "." + ii) >
                    -1
                  ) {
                    tmp[ii] = val;
                  }
                });
                if (!BsyUtils.isObjectEmpty(tmp)) {
                  subtmpdata.push(tmp);
                }
              });
              if (!BsyUtils.isObjectEmpty(subtmpdata)) {
                i[t] = subtmpdata;
              }
            } else {
              if (_opt.cacheFields.indexOf(e.options.widgetName) > -1) {
                if (a1 !== "" && !BsyUtils.isObjectEmpty(a1)) {
                  i[t] = a1;
                }
              }
            }
          }

          // if(_opt.cacheAllField || _opt.cacheFields.indexOf(e.options.widgetName) > -1 )
          // {
          //     let a1 = e.getValue();
          //
          //     if(!_opt.cacheAllField && e.getWidgetType() == 'subform')
          //     {
          //         let subtmpdata = [];
          //         FX.Utils.forEach(a1,function (i,subval) {
          //             let tmp = [];
          //             FX.Utils.forEach(subval,function (ii,val) {
          //
          //             })
          //         })
          //     }
          //     else
          //     {
          //         if(a1 !== "" &&  !FX.Utils.isObjectEmpty(a1))
          //         {
          //             i[t] = a1
          //         }
          //     }
          //
          //
          // }
        }
      });

      if (!BsyUtils.isObjectEmpty(i)) {
        window.FX.STATIC.user &&
          BsyUtils.forEach(function (t) {
            /formData[0-9a-f]{72}/.test(t) &&
              !new RegExp(window.FX.STATIC.user._id).test(t) &&
              BsyUtils.Store.remove(t);
          });
        BsyUtils.Store.set(
          this.getFormDataKey(),
          {
            data: i,
            time: e.updateTime,
          },
          1
        );
      }

      // FX.Utils.isObjectEmpty(i) || (FX.STATIC.user && BsyUtils.Store.forEach(function (t) {
      //     /formData[0-9a-f]{72}/.test(t) && !new RegExp(FX.STATIC.user._id).test(t) && BsyUtils.Store.remove(t)
      // }),
      // BsyUtils.Store.set(this.getFormDataKey(), {
      //     data: i,
      //     time: e.updateTime
      // }, 1))
    }
  };

  _checkFile = (widgetMap, cb) => {
    let _options = this.options;
    if (BsyUtils.isObjectEmpty(widgetMap)) {
      cb && cb(widgetMap);
      return !1;
    }

    //验证控件 缓存文件是存有效
    window.FX.Utils.dataAjax(
      {
        url: "/data/cache_file_check",
        async: false,
        data: {
          appId: _options.appId,
          entryId: _options.entryId,
          widgetMap: widgetMap,
        },
      },
      function (f) {
        cb && cb(f);
      }
    );
  };

  _bindCacheEvent = () => {
    let e = this;
    if (this.options.cacheEnable) {
      window.FX.FORMCACHE = this;
      window.$(window).one("unload", function () {
        if (window.FX.FORMCACHE) e.saveFormData();
        console.log("-------------------unload-------------------------");
      });
    }

    // this.options.cacheEnable && (FX.FORMCACHE = this,
    //     a(window).one("unload", function() {
    //         e.saveFormData()
    //     }))
  };

  renderSubmitBtn = (cb) => {
    const { submitText, submitButton, flows } = this.options;
    if (submitButton) {
      let visible = submitButton.hasOwnProperty("visible")
        ? submitButton.visible
        : true;
      if (!visible) {
        return "";
      }
      let text = submitButton.text || submitText;
      let styles = {};
      if (submitButton.color) {
        styles = {
          "background-color": submitButton.color,
          border: `1px solid ${submitButton.color}`,
        };
      }

      return (
        <BsyIconBtn
          key={"submitButt" + this.renderIndex}
          customCls={"form-custom"}
          text={text}
          // type="blue"
          style={styles}
          click={(e) => {
            cb && cb(e);
          }}
          mode={window.mode}
        ></BsyIconBtn>
      );
    }

    if (submitText) {
      return (
        <BsyIconBtn
          key={"submitButt" + this.renderIndex}
          text={
            flows
              ? flows.hasOwnProperty("submit_text")
                ? flows.submit_text
                : submitText
              : submitText
          }
          type="blue"
          visible={
            flows
              ? flows.hasOwnProperty("allowSubmit")
                ? flows.allowSubmit
                : true
              : true
          }
          click={(e) => {
            cb && cb(e);
          }}
          mode={window.mode}
        ></BsyIconBtn>
      );
    }
    return "";
  };

  renderBtns = () => {
    const {
      submitText,
      printText,
      hasFlowPrint,
      flows,
      cancelText,
      flow,
      flowType,
      ignoreOptAuth,
    } = this.options;
    let that = this;

    if (flow && flowType) {
      // console.log(flow);
      return (
        <>
          {this.btns.map((event) => {
            return (
              <BsyIconBtn
                key={event.type}
                text={event.text}
                type={event.type}
                style={event.hasOwnProperty("style") ? event.style : {}}
                click={() => {
                  this.submitHandler(event.handler);
                }}
                mode={window.mode}
              ></BsyIconBtn>
            );
          })}
          {this.moreBtns.length ? (
            <BsyIconBtn
              text={React.language("more")}
              type={"white"}
              click={(e) => {
                let menu = [];
                this.moreBtns.map((event) => {
                  menu.push({
                    text: event.text,
                    click: () => {
                      this.submitHandler(event.handler);
                    },
                  });
                });
                BsyAlertMenu({
                  item: menu,
                  width: 100,
                  target: e.target,
                });
              }}
              mode={window.mode}
            ></BsyIconBtn>
          ) : (
            ""
          )}
        </>
      );
    }

    return (
      <>
        {window.FX.STATIC.FTOKEN ? (
          <>
            {!ignoreOptAuth && hasFlowPrint && printText ? (
              <BsyIconBtn
                text={printText}
                type="blue"
                click={() => {
                  this.needPrint = !0;
                  this.doVerifyAndSubmit();
                }}
                mode={window.mode}
              ></BsyIconBtn>
            ) : (
              ""
            )}
            {
              this.renderSubmitBtn(() => {
                this.needPrint = !1;
                this.doVerifyAndSubmit();
              })
              // text ? <BsyIconBtn
              //     text={text}
              //     type="blue"
              //     click={e => {
              //         this.needPrint = !1;
              //         this.doVerifyAndSubmit()
              //     }}
              //     mode={window.mode}

              // ></BsyIconBtn> : ''
            }
          </>
        ) : (
          <>
            {!ignoreOptAuth && hasFlowPrint && printText ? (
              <BsyIconBtn
                text={printText}
                type="blue"
                click={() => {
                  this.needPrint = !0;
                  this.doVerifyAndSubmit();
                }}
                mode={window.mode}
              ></BsyIconBtn>
            ) : (
              ""
            )}
            {
              flows && flows.hasOwnProperty("allowSubmit")
                ? flows.allowSubmit
                  ? this.renderSubmitBtn(() => {
                    this.needPrint = !1;
                    if (!ignoreOptAuth) this.doVerifyAndSubmit();
                    else {
                      this.doVerifyAndSubmit({ skipFlow: true });
                    }
                  })
                  : ""
                : this.renderSubmitBtn(() => {
                  this.needPrint = !1;
                  this.doVerifyAndSubmit();
                })

              // <BsyIconBtn
              // text={text}
              // type="blue"
              // click={e => {
              //     this.needPrint = !1;
              //     this.doVerifyAndSubmit()
              // }}
              // mode={window.mode}

              // />
            }
            {!window.FX.STATIC.FTOKEN && flows && flows.allowSave ? (
              <BsyIconBtn
                text={flows.save_text}
                type="blue"
                click={() => {
                  this.needPrint = !1;
                  this.flowAction = "save";
                  if (!ignoreOptAuth)
                    this.doVerifyAndSubmit({ flowAction: this.flowAction });
                  else {
                    this.doVerifyAndSubmit({
                      flowAction: this.flowAction,
                      skipFlow: true,
                    });
                  }
                }}
                mode={window.mode}
              ></BsyIconBtn>
            ) : (
              ""
            )}
            {cancelText ? (
              <BsyIconBtn
                text={cancelText}
                type="blue"
                click={() => {
                  this.needPrint = !1;
                  window.FX.STATIC.DATAID = null;
                  BsyUtils.applyFunc(
                    that,
                    that.options.onAfterCancel,
                    [!1],
                    !0
                  );
                }}
                mode={window.mode}
              ></BsyIconBtn>
            ) : (
              ""
            )}
          </>
        )}
      </>
    );
  };

  getCommentContext = (context) => {
    this.commentContext = context;
  };

  getSignatureContext = (context) => {
    this.signatureContext = context;
  };

  renderCommentPane = () => {
    const { flow, appId, formId, dataId, widgetName } = this.options;
    if (!flow) {
      return "";
    }
    return (
      <div className="comment-pane">
        {flow.comment && flow.comment.enable ? (
          <div className="comment" key={"comment"}>
            <div className="title">
              {flow.comment.required ? (
                <span style={{ color: "red" }}>*</span>
              ) : (
                ""
              )}
              <span>{React.language("form.comment")}</span>
            </div>
            <BsyTextArea
              value={this.flowComment.comment}
              onStopEdit={(val) => {
                this.flowComment.comment = val;
              }}
              width={"auto"}
              height={80}
              allowBlank={!flow.comment.required}
              getContext={this.getCommentContext}
            ></BsyTextArea>
          </div>
        ) : (
          ""
        )}
        {flow.signature && flow.signature.enable ? (
          <div className="signature" key={"signature"}>
            <div className="title">
              <span style={{ color: "red" }}>*</span>
              <span>{React.language("Approval.signature")}</span>
            </div>
            <BsySignature
              allowBlank={false}
              value={this.flowComment.signature}
              onStopEdit={(val) => {
                this.flowComment.signature = val;
              }}
              appId={appId}
              formId={formId}
              dataId={dataId}
              widgetName={widgetName}
              height={"auto"}
              getContext={this.getSignatureContext}
            ></BsySignature>
          </div>
        ) : (
          ""
        )}
      </div>
    );
  };

  renderFooter = () => {
    const {
      formTheme,
      buttonPosition,
      hasComment,
      hasLog,
      hasFlowLog,
      ignoreOptAuth,
      printText,
      hasFlowPrint,
      flows,
    } = this.options;
    let haslog =
      hasLog || hasComment || hasFlowLog || ignoreOptAuth ? true : false;
    if (this.options.mode === "new") {
      haslog = false;
    }
    if (BsyUtils.isObjectEmpty(formTheme)) {
      return (
        <div className={"bsy-footer " + (haslog ? "hasLog " : " ")}>
          {this.renderCommentPane()}

          <div className={"btn-pane " + buttonPosition}>
            {this.renderBtns()}
          </div>
        </div>
      );
    }
    const { mode, system, custom } = formTheme;
    let d = BsyConfig().THEME.EXTERNAL_FORM_THEME[system];
    if (mode != "system") {
      d = { ...d, ...custom };
    }

    return (
      <div className={"bsy-footer " + (haslog ? "hasLog" : "")}>
        <div className={"btn-pane " + buttonPosition}>
          {hasFlowPrint && printText ? (
            <BsyIconBtn
              style={{
                backgroundColor: d.submit_btn["background-color"],
                color: "#fff",
              }}
              text={printText}
              type={
                d.submit_btn && d.submit_btn["background-color"] ? "" : "blue"
              }
              click={() => {
                this.needPrint = !0;
                this.doVerifyAndSubmit();
              }}
              mode={window.mode}
            ></BsyIconBtn>
          ) : (
            ""
          )}
          <BsyIconBtn
            style={{
              backgroundColor: d.submit_btn["background-color"],
              color: "#fff",
            }}
            text={this.options.submitText}
            visible={
              flows
                ? flows.hasOwnProperty("allowSubmit")
                  ? flows.allowSubmit
                  : true
                : true
            }
            type={
              d.submit_btn && d.submit_btn["background-color"] ? "" : "blue"
            }
            click={() => {
              this.doVerifyAndSubmit();
            }}
            mode={window.mode}
          ></BsyIconBtn>
        </div>
      </div>
    );
  };

  getSideKey = () => {
    const { appId, entryId, authGroupId, formId } = this.options;
    return BsyUtils.Store.getKey("datafullside", {
      appId: appId,
      entryId: formId || entryId,
      authGroupId: BsyUtils.isNumber(authGroupId) ? authGroupId : "",
    });
  };

  getSideStatus = () => {
    return BsyUtils.Store.get(this.getSideKey()) || "false";
  };

  setSideStatus = (val) => {
    return BsyUtils.Store.set(this.getSideKey(), val);
  };

  getfullscreenKey = () => {
    const { appId, entryId, authGroupId, formId } = this.options;
    return BsyUtils.Store.getKey("datafullscreen", {
      appId: appId,
      entryId: formId || entryId,
      authGroupId: BsyUtils.isNumber(authGroupId) ? authGroupId : "",
    });
  };

  getfullscreenStatus = () => {
    return BsyUtils.Store.get(this.getfullscreenKey()) || "false";
  };

  setfullscreenStatus = (val) => {
    return BsyUtils.Store.set(this.getfullscreenKey(), val);
  };

  regenerationSubformId = () => {
    let result = this.options.resultWidgets;
    BsyUtils.forEach(result, (v1, item) => {
      if (item.field.type === "subform") {
        var tmpval = this.grfeg(item.getObjectValue());
        item.field.setValue(tmpval);
      }
    });
    // let item = result[i];//.getObjectValue();
    // if (item.field.type === 'subform') {
    //     var tmpval = this.grfeg(item.getObjectValue());
    //     item.field.setValue(tmpval)
    // }
    // }
    this.getCacheValue();
  };

  grfeg = (val) => {
    if (BsyUtils.isObjectEmpty(val)) {
      return val;
    }
    for (let i = 0; i < val.length; i++) {
      val[i].rowId = val[i].id = BsyUtils.Ids24();
    }
    return [...val];
  };
  _setWidgetVisible = (t, e) => {
    var i,
      a = this.getWidgetByName(t);

    if (a) {
      this.widgetVisibleMap || (this.widgetVisibleMap = {});
      i = a.isVisible();

      if (i && e) {
        this.widgetVisibleMap[t] = !0;
      } else {
        this.widgetVisibleMap[t] = !1;
      }
    }
  };

  // showtabs 此属性，获取标签页内部的控件显示属性，直接强行全部显示或者隐藏
  _refreshMultiTab = (showtabs) => {
    var t,
      i,
      e = this.options;
    var that = this;
    if (this.multiTab && this.multiTab.current) {
      if (BsyUtils.isObjectEmpty(showtabs)) {
        return;
      }

      t = BsyUtils.getNoEmptyTabs(this._getTabItems(), e.multiTabs);
      i = [];
      BsyUtils.forEach(t, function (t, e) {
        i.push(e.name);
      });
      e = this.multiTab.current.getActiveTabName();
      i.indexOf(e) < 0 && this.multiTab.current.setActiveTabName(i[0]);

      //处理强制显示逻辑
      var showtab = [];
      var hidetab = [];
      BsyUtils.forEach(showtabs, function (tindex, tdata) {
        if (tdata == true) {
          showtab.push(tindex);
        } else {
          hidetab.push(tindex);
        }
      });
      BsyUtils.forEach(t, function (tindex, tdata) {
        showtab.push(tdata.name);
      });

      var tab = [];
      i = [];
      that.multiTab.current.removeHideTabName();
      BsyUtils.forEach(this.options.multiTabs, function (tindex, tdata) {
        if (hidetab.indexOf(tdata.name) > -1) {
          that.multiTab.current.setHideTabName(tdata.name);
          //直接全部隐藏
          return;
        }
        if (showtab.indexOf(tdata.name) > -1) {
          tab.push(tdata);
          i.push(tdata.name);
        }
      });
      this.multiTab.current.refreshWithConfig(tab);
      if (i.length > 0) {
        let index = i.indexOf(e);
        if (index === -1) {
          this.multiTab.current.setActiveTabName(i[0]); //设置默认激活页面
        } else {
          this.multiTab.current.setActiveTabName(i[index]); //设置默认激活页面
        }
      }
    }
  };

  render() {
    const { items } = this;
    const {
      cssName,
      hasHeader,
      dataId,
      editValue,
      hasFooter,
      authGroupId,
      flowType,
      flowId,
      css,
      layout,
      multiTabs,
      flow,
      hasComment,
      hasLog,
      hasFlowLog,
      popupFormPath,
      ignoreOptAuth,
      entryId,
      appId,
      formId,
      forms,
      extDashData,
      mode,
      refAppId
    } = this.options;

    // console.log(`----------------form render ${this.renderIndex}-----------------------`)
    let that = this;
    let e = this._getTabItems();

    let hasflow =
      flow &&
        ((flow.comment && flow.comment.enable) ||
          (flow.signature && flow.signature.enable))
        ? true
        : false;

    let haslog =
      hasLog || hasComment || hasFlowLog || ignoreOptAuth ? true : false;
    if (mode === "new") {
      haslog = false;
    }
    css.width = "100%";

    let hasComment1 = false;
    if (flow) {
      if (flow.comment && flow.comment.enable) {
        hasComment1 = true;
      }
      if (flow.signature && flow.signature.enable) {
        hasComment1 = true;
      }
    }

    return (
      <div
        className={
          cssName +
          (css.height ? " bsy-form-modal" : "") +
          (hasflow ? " has-flow " : "") +
          (hasHeader ? " has-header " : "") +
          (hasFooter ? " has-footer " : "") +
          (layout ? " " + layout : "normal-layout")
        }
        style={css}
        ref={this.element}
      >
        {hasHeader ? this.renderHeader() : ""}
        <div
          className={
            "bsy-widget-wrapper " +
            (haslog ? "hasLog" : "") +
            (hasComment1 ? " hasComment " : "")
          }
          ref={this.wrapper}
        >
          <ul>
            {items.map(function (item) {
              // console.log(item)

              if (item.tab) {
                return "";
              }

              return that.createItem(item);
            })}
          </ul>
          {this._hasMultiTab() ? (
            <BsyFormMultiTab
              ref={this.multiTab}
              items={e}
              form={this}
              theme={
                this.props.formTabsStyle
                  ? this.props.formTabsStyle.theme
                  : "drop-down-type-one"
              }
              themeColor={
                this.props.formTabsStyle
                  ? this.props.formTabsStyle.themeColor
                  : "#0265FF"
              }
              tabs={BsyUtils.getNoEmptyTabs(e, multiTabs)}
              onCreateTabItem={(t, selectTab) => {
                return that.createItem(t, selectTab);
              }}
              onTabClick={() => { }}
            ></BsyFormMultiTab>
          ) : (
            ""
          )}
        </div>
        {hasFooter ? this.renderFooter() : ""}
        {haslog ? (
          <BsyFormLogPane
            {...{
              hasComment,
              hasLog,
              status: this.status,
              hasFlowLog,
              dataId: dataId,
              data: { ...editValue },
              fields: this.showFields || this.header || this.allShowFields,
              entryId: entryId,
              appId: appId || window.FX.STATIC.APPID,
              authGroupId: authGroupId,
              flowType: flowType,
              flowId: flowId,
              popupFormPath: popupFormPath,
              ignoreOptAuth: ignoreOptAuth,
              logs: this.state.logs,
              extDashData: extDashData,
              formId: formId || (BsyUtils.isArray(forms) ? forms[0] : forms),
              refAppId: refAppId,
              onExpand: (status) => {
                this.setSideStatus(status);
                if (status == "false") {
                  this.element.current.classList.remove("side");
                } else {
                  this.element.current.classList.add("side");
                }
              },
            }}
          ></BsyFormLogPane>
        ) : (
          ""
        )}
      </div>
    );
  }
}
